const getParam = (param) => {
  const currentUrl = new URL(window.location.href);
  return currentUrl.searchParams.get(param);
};

const setParam = (param, value, allowMultiple) => {
  const currentUrl = new URL(window.location.href);
  if (allowMultiple) {
    if (!currentUrl.searchParams.getAll(param).includes(value)) {
      currentUrl.searchParams.append(param, value);
    }
  } else {
    currentUrl.searchParams.set(param, value);
  }

  currentUrl.searchParams.sort();
  window.history.pushState({}, '', currentUrl);
};

const removeParam = (param, value) => {
  const currentUrl = new URL(window.location.href);
  if (value) {
    currentUrl.searchParams.delete(param, value);
  } else {
    currentUrl.searchParams.delete(param);
  }
  currentUrl.searchParams.sort();
  window.history.pushState({}, '', currentUrl);
};

const NOSTO_FIELDS = [
    'productId',
    'name',
    'url',
    'imageUrl',
    'thumbUrl',
    'description',
    'brand',
    'availability',
    'available',
    'price',
    'listPrice',
    'categoryIds',
    'categories',
    'tags1',
    'tags2',
    'tags3',
    'priceCurrencyCode',
    'datePublished',
    'inventoryLevel',
    'alternateImageUrls',
    'pid',
    'isExcluded',
    'onDiscount',
    'saleable',
    'customFields.key',
    'customFields.value',
    'skus.id',
    'skus.name',
    'skus.price',
    'skus.listPrice',
    'skus.availability',
    'skus.url',
    'skus.imageUrl',
    'skus.inventoryLevel',
    'skus.customFields.key',
    'skus.customFields.value',
  ];

async function getProducts(id, filter, sort, from, query, size = 24) {
  const collectionPayload = {};

  if (id) {
    collectionPayload.categoryId = id;
  }

  return new Promise((resolve, reject) => {
    nostojs(function (api) {
      api
        .search(
          {
            ...(query ? { query: query } : {}),
            products: {
              ...collectionPayload,
              facets: ["*"],
              fields: NOSTO_FIELDS,
              sort,
              from,
              size: size,
              filter
            }
          },
          {
            track: id ? 'category': 'serp',
            redirect: true
          }
        )
        .then(function (response) {
          resolve({ data: { search: response }});
        })
        .catch(function (error) {
          console.log('---error---', error);
          reject(error);
        });
    });
  })
}

const HEADER_SELECTOR = '.section-header';
const COLLECTION_CONTAINER_SELECTOR = '[data-ajax-scroll-to]';

const scrollTop = () => {
  const header = document.querySelector(HEADER_SELECTOR);
  const collectionContainer = document.querySelector(COLLECTION_CONTAINER_SELECTOR);
  if (header && collectionContainer) {
    const headerOffset = header.offsetHeight;
    const containerPosition = collectionContainer.getBoundingClientRect().top + window.scrollY;
    const scrollPosition = containerPosition - headerOffset;

    window.scrollTo({
      top: scrollPosition,
      behavior: 'smooth'
    });
  }
};

const UTILITY_BAR_CENTRE_SELECTOR = '.utility-bar__centre';
const UTILITY_BAR_ITEM_SELECTOR = '.utility-bar__item';

/**
   * Update count in the product grid
   * This function should be called when a filter is applied
   * element: .utility-bar__item
   */

const updateProductCount = (collectionListing, count, isSearch) => {
  const stringAttr = collectionListing.getAttribute('string');
  let string = {};
  if (stringAttr) {
    string = JSON.parse(stringAttr);
  }

  const barCentre = document.querySelector(UTILITY_BAR_CENTRE_SELECTOR);
  if (barCentre?.classList.contains('product-count--hidden')) {
    barCentre.classList.remove('product-count--hidden');
  }
  let barItem = '';
  if (barCentre) {
    barItem = barCentre.querySelector(UTILITY_BAR_ITEM_SELECTOR);
  }

  if (barItem) {
    if (isSearch) {
      const title = document.querySelector('title');
      if (title) {
        const currentContent = title.innerText;
        const updateContent = currentContent.replace(/(\d+)/, count);
        title.innerText = updateContent;
      }
    }
    if (count === 1) {
      barItem.innerText = string.product_count_one.replace('{{ count }}', count);
    } else {
      barItem.innerText = string.product_count_other.replace('{{ count }}', count);
    }
  }
};

const getProductCountTitle = (resultCount) => {
  if (!resultCount) return 'No products found'
  const query = getParam('q') ?? '';
  return `${resultCount} result${resultCount > 1 ? 's' : ''} found for "${query}"`
};

const COLLECTION_FILTER_SELECTOR = 'collection-filter';
const COLLECTION_APPLIED_FILTERS_SELECTOR = 'collection-applied-filters';
const COLLECTION_LISTING_SELECTOR$1 = 'collection-listing';
const COLLECTION_PAGINATION_SELECTOR = 'collection-pagination';
const COLLECTION_FILTER_TOOLBAR_SELECTOR = 'collection-filter-toolbar';
const COLLECTION_RESULTS_SELECTOR = '.js-template-search';

const collectionFilter = document.querySelector(COLLECTION_FILTER_SELECTOR);
const collectionAppliedFilters = document.querySelector(COLLECTION_APPLIED_FILTERS_SELECTOR);
const collectionListing = document.querySelector(COLLECTION_LISTING_SELECTOR$1);
const collectionPagination = document.querySelector(COLLECTION_PAGINATION_SELECTOR);
const collectionFilterToolbar = document.querySelector(COLLECTION_FILTER_TOOLBAR_SELECTOR);
const collectionResultsGrid = document.querySelector(COLLECTION_RESULTS_SELECTOR);

const DEFAULT_SIZE = 24;
let size = DEFAULT_SIZE;
let collection = {};
if (collectionListing) {
  const collectionAttr = collectionListing.getAttribute('collection');
  if (collectionAttr) {
    collection = JSON.parse(collectionAttr);
  }
  const sectionSettingsAttr = collectionListing.getAttribute('section-settings') || '{}';
  {
    const sectionSettings = JSON.parse(sectionSettingsAttr);
    if (Object.prototype.hasOwnProperty.call(sectionSettings, 'products_per_page')) {
      size = sectionSettings.products_per_page;
    }
  }
}

const query$1 = getParam('q');

const nostoGetProducts = (filter = [], sort = [], from = 0, isScrollTop = true, getPriceRange = false, revertHref) => {
  if (!collectionListing) {
    return
  }

  if (!isScrollTop && !getPriceRange) {
    collectionListing.firstLoading = true;
  }
  if (!getPriceRange) {
    collectionListing.loading = true;
  }
  if (collectionFilter) {
    collectionFilter.loading = true;
  }
  if (collectionAppliedFilters) {
    collectionAppliedFilters.loading = true;
  }
  if (collectionFilterToolbar) {
    collectionFilterToolbar.loading = true;
  }
  if (collectionResultsGrid) {
    collectionResultsGrid.classList.add('loading');
  }

  const fromItem = Math.floor(from / DEFAULT_SIZE) * size;
  return getProducts(collection.id, filter, sort, fromItem, query$1, size)
    .then((result) => {
      const response = result.data?.search?.products;
      // Send response to the components
      if (collectionFilter) {
        collectionFilter.resultCount = response?.total ?? 0;
        if (!getPriceRange) {
          collectionFilter.filters = response?.facets;
        } else {
          const filterAvailability = response?.facets?.find(filter => filter.field === 'availability');
          if (filterAvailability) {
            collectionFilter.availability = filterAvailability.data;
          }
        }
      }
      if (collectionAppliedFilters) {
        collectionAppliedFilters.resultCount = response?.total ?? 0;
        if (!getPriceRange) {
          collectionAppliedFilters.filters = response?.facets;
        } else {
          const filterPrice = response?.facets?.find(filter => filter.type === 'stats');
          if (filterPrice) {
            collectionAppliedFilters.rangeMin = filterPrice.min;
            collectionAppliedFilters.rangeMax = filterPrice.max;
          }
        }
      }
      if (collectionFilterToolbar) {
        collectionFilterToolbar.resultCount = response?.total ?? 0;
      }
      if (collectionListing) {
        if (!getPriceRange) {
          updateProductCount(collectionListing, response?.total, query$1 ? true : false);
          if (isScrollTop) {
            scrollTop();
          } else {
            collectionListing.firstLoading = false;
          }
          collectionListing.products = response?.hits;
          collectionListing.loading = false;
          setTimeout(() => {
            document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
          }, 300);
        }
      }
      if (collectionPagination) {
        if (!getPriceRange) {
          collectionPagination.pagination = response;
          collectionPagination.loading = false;
        }
      }
      if (revertHref) {
        revertHref();
      }
    })
    .finally(() => {
      if (collectionFilter) {
        collectionFilter.firstLoad = false;
        collectionFilter.loading = false;
      }
      if (collectionFilterToolbar) {
        collectionFilterToolbar.loading = false;
      }
      if (collectionAppliedFilters) {
        collectionAppliedFilters.loading = false;
      }
      if (collectionResultsGrid) {
        collectionResultsGrid.classList.remove('loading');
      }
    })
};

const sortInput = (sortBy) => {
  let sort = [];
   switch (sortBy) {
    case 'title-ascending':
      sort = [{
        field: 'name',
        order: 'asc'
      }];
      break;
    case 'title-descending':
      sort = [{
        field: 'name',
        order: 'desc'
      }];
      break;
    case 'price-ascending':
      sort = [{
        field: 'price',
        order: 'asc'
      }];
      break;
    case 'price-descending':
      sort = [{
        field: 'price',
        order: 'desc'
      }];
      break;
    case 'created-ascending':
      sort = [{
        field: 'datePublished',
        order: 'asc'
      }];
      break;
    case 'created-descending':
      sort = [{
        field: 'datePublished',
        order: 'desc'
      }];
      break;
    }

    return sort;
};

const handleSortChange = (value) => {
  setParam('sort_by', value);
  const apiInput = convertParams();
  nostoGetProducts(apiInput.filter, apiInput.sort, apiInput.from);
};

const SORT_OPTIONS = [
  {
    label: 'Relevance',
    value: 'relevance'
  },
  {
    label: 'Alphabetically, A-Z',
    value: 'title-ascending'
  },
  {
    label: 'Alphabetically, Z-A',
    value: 'title-descending'
  },
  {
    label: 'Price, low to high',
    value: 'price-ascending'
  },
  {
    label: 'Price, high to low',
    value: 'price-descending'
  },
  {
    label: 'Date, old to new',
    value: 'created-ascending'
  },
  {
    label: 'Date, new to old',
    value: 'created-descending'
  }
];

const getSortLabel = () => {
  const currentSort = getParam('sort_by') ?? '';
  const sortOption = SORT_OPTIONS.find(option => option.value === currentSort);
  if (!sortOption) return null;
  return sortOption.label;
};

const convertParams = () => {
  const currentUrl = new URL(window.location.href);
  const searchParams = new URLSearchParams(currentUrl.search);
  const paramsArray = Array.from(searchParams.entries());
  const results = {
    filter: [],
    sort: [],
    from: 0
  };

  if (paramsArray.length) {
    paramsArray.map(([key, value]) => {
      if (key === 'page') {
        results.from = Number(24*(value-1));
      } else if (key === 'sort_by') {
        results.sort = sortInput(value);
      } else if (key.includes('filter.')) {
        const isPriceMin = key.includes('price.min');
        const isPriceMax = key.includes('price.max');
        const filterKey = (isPriceMin || isPriceMax) ? 'price' : key.replace('filter.', '');
        let isKeyExist = false;
        if (results.filter.some(filter => filter.field === filterKey)) {
          isKeyExist = true;
        }
        if (isKeyExist) {
          results.filter.map(filter => {
            if (filter.field === filterKey) {
              if (isPriceMin) {
                filter.range.gt = value;
              } else if (isPriceMax) {
                filter.range.lt = value;
              } else {
                filter.value.push(value);
              }
            }
          });
        } else {
          if (isPriceMin || isPriceMax) {
            results.filter.push({
              field: filterKey,
              range: {
                ...(isPriceMin && { gt: value }),
                ...(isPriceMax && { lt: value })
              }
            });
          } else {
            results.filter.push({
              field: filterKey,
              value: [value]
            });
          }
        }
      }
    });
  }

  //Always apply the first sort option by default
  if (!results.sort.length) {
    results.sort = sortInput(SORT_OPTIONS[0].value);
  }

  return results
};

const implementFilterSettings = (element) => {
  if (!element) return;
  const filterSettingsAttr = element.getAttribute('filter-settings');
  if (filterSettingsAttr) {
    try {
      const parsedFilterSettings = JSON.parse(filterSettingsAttr);
      element.filterSettings = {
        ...parsedFilterSettings,
        enable_sticky: parsedFilterSettings.enable_sticky === 'true',
        enable_sorting: parsedFilterSettings.enable_sorting === 'true',
        enable_filtering: parsedFilterSettings.enable_filtering === 'true',
        enable_viewing: parsedFilterSettings.enable_viewing === 'true',
      };
    } catch (e) {
      element.filterSettings = {};
    }
  }
};

const convertFilterValue = (value) => {
  if (value.indexOf('["') !== -1) {
    return JSON.parse(value).join(' / ')
  }

  switch (value) {
    case 'InStock':
      return 'In Stock'
    case 'OutOfStock':
      return 'Out Of Stock'
  }
  return value
};

const implementProductSettings = (element) => {
  if (!element) return;
  const productSettingsAttr = element.getAttribute('product-settings');
  if (productSettingsAttr) {
    try {
      const parsedProductSettings = JSON.parse(productSettingsAttr);
      element.productSettings = {
        ...parsedProductSettings,
        show_secondary_image: parsedProductSettings.show_secondary_image === 'true',
        show_vendor: parsedProductSettings.show_vendor === 'true',
        show_rating: parsedProductSettings.show_rating === 'true',
        show_quick_buy: parsedProductSettings.show_quick_buy === 'true',
        enable_quick_view: parsedProductSettings.enable_quick_view === 'true',
        enable_color_swatches: parsedProductSettings.enable_color_swatches === 'true',
        enable_countdown: parsedProductSettings.enable_countdown === 'true',
        enable_image_fill: parsedProductSettings.enable_image_fill === 'true',
      };
    } catch (e) {
      element.productSettings = {};
    }
  }
};

const implementSearchSectionSettings = (element) => {
  if (!element) return;
  const searchSettingsAttr = element.getAttribute('section-settings');
  if (searchSettingsAttr) {
    try {
      const parsedSearchSettings = JSON.parse(searchSettingsAttr);
      element.sectionSettings = {
        ...parsedSearchSettings
      };
    } catch (e) {
      element.sectionSettings = {};
    }
  }
};

const excludeFilterOptions = (filter, filterName = '', excludeOptions = []) => {
  const lowerCaseFilterName = filterName.toLowerCase();
  if (!filter || !filter.name || (filter.name.toLowerCase() !== lowerCaseFilterName)) return filter;

  const filterOptions = filter.data;
  if (!filterOptions || !filterOptions.length) return filter;

  excludeOptions = excludeOptions.map(option => option.toLowerCase().trim());
  filter.data = filterOptions.filter(option => {
    const optionName = option.value.toLowerCase();
    return !excludeOptions.includes(optionName);
  });
  return filter;
};

function InitPriceRange(container) {
  this.container = container;
  this.selectors = {
    inputMin: '.cc-price-range__input--min',
    inputMax: '.cc-price-range__input--max',
    control: '.cc-price-range__control',
    controlMin: '.cc-price-range__control--min',
    controlMax: '.cc-price-range__control--max',
    bar: '.cc-price-range__bar',
    activeBar: '.cc-price-range__bar-active'
  };

  this.controls = {
    min: {
      barControl: container.querySelector(this.selectors.controlMin),
      input: container.querySelector(this.selectors.inputMin)
    },
    max: {
      barControl: container.querySelector(this.selectors.controlMax),
      input: container.querySelector(this.selectors.inputMax)
    }
  };

  this.controls.min.value = parseInt(this.controls.min.input.value === '' ? this.controls.min.input.placeholder : this.controls.min.input.value);
  this.controls.max.value = parseInt(this.controls.max.input.value === '' ? this.controls.max.input.placeholder : this.controls.max.input.value);
  this.valueMin = this.controls.min.input.min;
  this.valueMax = this.controls.min.input.max;
  this.valueRange = this.valueMax - this.valueMin;

  [this.controls.min, this.controls.max].forEach(item => {
    item.barControl.setAttribute('aria-valuemin', this.valueMin);
    item.barControl.setAttribute('aria-valuemax', this.valueMax);
    item.barControl.setAttribute('tabindex', 0);
  });

  this.controls.min.barControl.setAttribute('aria-valuenow', this.controls.min.value);
  this.controls.max.barControl.setAttribute('aria-valuenow', this.controls.max.value);

  this.bar = container.querySelector(this.selectors.bar);
  this.activeBar = container.querySelector(this.selectors.activeBar);
  this.inDrag = false;

  // Methods
  this.getPxToValueRatio = function () {
    return this.bar.clientWidth / (this.valueMax - this.valueMin);
  };

  this.getPcToValueRatio = function () {
    return 100.0 / (this.valueMax - this.valueMin);
  };

  this.setActiveControlValue = function (value) {
    if (isNaN(parseInt(value))) return;

    if (this.activeControl === this.controls.min) {
      if (value === '') value = this.valueMin;
      value = Math.max(this.valueMin, value);
      value = Math.min(value, this.controls.max.value);
    } else {
      if (value === '') value = this.valueMax;
      value = Math.min(this.valueMax, value);
      value = Math.max(value, this.controls.min.value);
    }

    this.activeControl.value = Math.round(value);

    if (this.activeControl.input.value != this.activeControl.value) {
      this.activeControl.input.value = (this.activeControl.value == this.activeControl.input.placeholder) ? '' : this.activeControl.value;
      this.activeControl.input.dispatchEvent(new CustomEvent('change', { bubbles: true, cancelable: false, detail: { sender: 'theme:component:price_range' } }));
    }

    this.activeControl.barControl.setAttribute('aria-valuenow', this.activeControl.value);
  };

  this.render = function () {
    this.drawControl(this.controls.min);
    this.drawControl(this.controls.max);
    this.drawActiveBar();
  };

  this.drawControl = function (control) {
    control.barControl.style.left = (control.value - this.valueMin) * this.getPcToValueRatio() + '%';
  };

  this.drawActiveBar = function () {
    this.activeBar.style.left = (this.controls.min.value - this.valueMin) * this.getPcToValueRatio() + '%';
    this.activeBar.style.right = (this.valueMax - this.controls.max.value) * this.getPcToValueRatio() + '%';
  };

  this.handleControlTouchStart = function (e) {
    e.preventDefault();
    this.startDrag(e.target, e.touches[0].clientX);
    this.boundControlTouchMoveEvent = this.handleControlTouchMove.bind(this);
    this.boundControlTouchEndEvent = this.handleControlTouchEnd.bind(this);
    window.addEventListener('touchmove', this.boundControlTouchMoveEvent);
    window.addEventListener('touchend', this.boundControlTouchEndEvent);
  };

  this.handleControlTouchMove = function (e) {
    this.moveDrag(e.touches[0].clientX);
  };

  this.handleControlTouchEnd = function (e) {
    e.preventDefault();
    window.removeEventListener('touchmove', this.boundControlTouchMoveEvent);
    window.removeEventListener('touchend', this.boundControlTouchEndEvent);
    this.stopDrag();
  };

  this.handleControlMouseDown = function (e) {
    e.preventDefault();
    this.startDrag(e.target, e.clientX);
    this.boundControlMouseMoveEvent = this.handleControlMouseMove.bind(this);
    this.boundControlMouseUpEvent = this.handleControlMouseUp.bind(this);
    window.addEventListener('mousemove', this.boundControlMouseMoveEvent);
    window.addEventListener('mouseup', this.boundControlMouseUpEvent);
  };

  this.handleControlMouseMove = function (e) {
    this.moveDrag(e.clientX);
  };

  this.handleControlMouseUp = function (e) {
    e.preventDefault();
    window.removeEventListener('mousemove', this.boundControlMouseMoveEvent);
    window.removeEventListener('mouseup', this.boundControlMouseUpEvent);
    this.stopDrag();
  };

  this.startDrag = function (target, startX) {
    this.activeControl = (this.controls.min.barControl === target) ? this.controls.min : this.controls.max;
    this.dragStartX = startX;
    this.dragStartValue = this.activeControl.value;
    this.inDrag = true;
  };

  this.moveDrag = function (moveX) {
    if (this.inDrag) {
      var value = this.dragStartValue + (moveX - this.dragStartX) / this.getPxToValueRatio();
      this.setActiveControlValue(value);
      this.render();
    }
  };

  this.stopDrag = function () {
    this.inDrag = false;
  };

  this.handleControlKeyDown = function (e) {
    if (e.key === 'ArrowRight') {
      this.incrementControlFromKeypress(e.target, 10.0);
    } else if (e.key === 'ArrowLeft') {
      this.incrementControlFromKeypress(e.target, -10);
    }
  };

  this.incrementControlFromKeypress = function (control, pxAmount) {
    this.activeControl = (this.controls.min.barControl === control) ? this.controls.min : this.controls.max;
    this.setActiveControlValue(this.activeControl.value + pxAmount / this.getPxToValueRatio());
    this.render();
  };

  this.handleInputChange = function (e) {
    e.target.value = e.target.value.replace(/\D/g, '');

    if (!e.detail || e.detail.sender != 'theme:component:price_range') {
      this.activeControl = (this.controls.min.input === e.target) ? this.controls.min : this.controls.max;
      this.setActiveControlValue(e.target.value);
      this.render();
    }
  };

  this.handleInputKeyup = function (e) {
    setTimeout(function () {
      this.value = this.value.replace(/\D/g, '');
    }.bind(e.target), 10);
  };

  this.bindEvents = function () {
    [this.controls.min, this.controls.max].forEach(item => {
      item.barControl.addEventListener('touchstart', this.handleControlTouchStart.bind(this));
      item.barControl.addEventListener('mousedown', this.handleControlMouseDown.bind(this));
      item.barControl.addEventListener('keydown', this.handleControlKeyDown.bind(this));
      item.input.addEventListener('change', this.handleInputChange.bind(this));
      item.input.addEventListener('keyup', this.handleInputKeyup.bind(this));
    });
  };

  this.bindEvents();
  this.render();

  this.destroy = function () {
    // Cleanup logic if needed
  };
}

const resetPriceRange = (rangeMin, rangeMax) => {
  const rangeInputMin = document.querySelector('.cc-price-range__input--min');
  const rangeInputMax = document.querySelector('.cc-price-range__input--max');
  const rangeControlMin = document.querySelector('.cc-price-range__control--min');
  const rangeControlMax = document.querySelector('.cc-price-range__control--max');
  const rangeBarActive = document.querySelector('.cc-price-range__bar-active');
  if (rangeInputMin && rangeInputMax && rangeControlMin && rangeControlMax && rangeBarActive) {
    rangeInputMin.value = rangeMin;
    rangeInputMin.setAttribute('value', rangeMin);
    rangeInputMax.value = rangeMax;
    rangeInputMax.setAttribute('value', rangeMax);
    rangeControlMin.style.left = '0%';
    rangeControlMin.setAttribute('aria-valuenow', rangeMin);
    rangeControlMax.style.left = '100%';
    rangeControlMax.setAttribute('aria-valuenow', rangeMax);
    rangeBarActive.style.left = '0%';
    rangeBarActive.style.right = '0%';
  }
};

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

const moneyFormat$1 = '${{amount}}';

/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @param  {String} format - shop money_format setting
 * @return {String} value - formatted value
 */
function formatMoney$1(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat$1;

  function formatWithDelimiters(
    number,
    precision = 2,
    thousands = ',',
    decimal = '.'
  ) {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`
    );
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

const moneyFormat = window.Shopify.money_format ?? theme.money_format;

const formatMoney = function (cents, format = moneyFormat) {
  return formatMoney$1(cents, format)
};

/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t$3=globalThis,e$5=t$3.ShadowRoot&&(void 0===t$3.ShadyCSS||t$3.ShadyCSS.nativeShadow)&&"adoptedStyleSheets"in Document.prototype&&"replace"in CSSStyleSheet.prototype,s$4=Symbol(),o$5=new WeakMap;let n$4 = class n{constructor(t,e,o){if(this._$cssResult$=true,o!==s$4)throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");this.cssText=t,this.t=e;}get styleSheet(){let t=this.o;const s=this.t;if(e$5&&void 0===t){const e=void 0!==s&&1===s.length;e&&(t=o$5.get(s)),void 0===t&&((this.o=t=new CSSStyleSheet).replaceSync(this.cssText),e&&o$5.set(s,t));}return t}toString(){return this.cssText}};const r$4=t=>new n$4("string"==typeof t?t:t+"",void 0,s$4),S$1=(s,o)=>{if(e$5)s.adoptedStyleSheets=o.map((t=>t instanceof CSSStyleSheet?t:t.styleSheet));else for(const e of o){const o=document.createElement("style"),n=t$3.litNonce;void 0!==n&&o.setAttribute("nonce",n),o.textContent=e.cssText,s.appendChild(o);}},c$3=e$5?t=>t:t=>t instanceof CSSStyleSheet?(t=>{let e="";for(const s of t.cssRules)e+=s.cssText;return r$4(e)})(t):t;

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const{is:i$4,defineProperty:e$4,getOwnPropertyDescriptor:h$5,getOwnPropertyNames:r$3,getOwnPropertySymbols:o$4,getPrototypeOf:n$3}=Object,a$1=globalThis,c$2=a$1.trustedTypes,l$2=c$2?c$2.emptyScript:"",p$2=a$1.reactiveElementPolyfillSupport,d$2=(t,s)=>t,u$2={toAttribute(t,s){switch(s){case Boolean:t=t?l$2:null;break;case Object:case Array:t=null==t?t:JSON.stringify(t);}return t},fromAttribute(t,s){let i=t;switch(s){case Boolean:i=null!==t;break;case Number:i=null===t?null:Number(t);break;case Object:case Array:try{i=JSON.parse(t);}catch(t){i=null;}}return i}},f$3=(t,s)=>!i$4(t,s),b={attribute:true,type:String,converter:u$2,reflect:false,useDefault:false,hasChanged:f$3};Symbol.metadata??=Symbol("metadata"),a$1.litPropertyMetadata??=new WeakMap;let y$1 = class y extends HTMLElement{static addInitializer(t){this._$Ei(),(this.l??=[]).push(t);}static get observedAttributes(){return this.finalize(),this._$Eh&&[...this._$Eh.keys()]}static createProperty(t,s=b){if(s.state&&(s.attribute=false),this._$Ei(),this.prototype.hasOwnProperty(t)&&((s=Object.create(s)).wrapped=true),this.elementProperties.set(t,s),!s.noAccessor){const i=Symbol(),h=this.getPropertyDescriptor(t,i,s);void 0!==h&&e$4(this.prototype,t,h);}}static getPropertyDescriptor(t,s,i){const{get:e,set:r}=h$5(this.prototype,t)??{get(){return this[s]},set(t){this[s]=t;}};return {get:e,set(s){const h=e?.call(this);r?.call(this,s),this.requestUpdate(t,h,i);},configurable:true,enumerable:true}}static getPropertyOptions(t){return this.elementProperties.get(t)??b}static _$Ei(){if(this.hasOwnProperty(d$2("elementProperties")))return;const t=n$3(this);t.finalize(),void 0!==t.l&&(this.l=[...t.l]),this.elementProperties=new Map(t.elementProperties);}static finalize(){if(this.hasOwnProperty(d$2("finalized")))return;if(this.finalized=true,this._$Ei(),this.hasOwnProperty(d$2("properties"))){const t=this.properties,s=[...r$3(t),...o$4(t)];for(const i of s)this.createProperty(i,t[i]);}const t=this[Symbol.metadata];if(null!==t){const s=litPropertyMetadata.get(t);if(void 0!==s)for(const[t,i]of s)this.elementProperties.set(t,i);}this._$Eh=new Map;for(const[t,s]of this.elementProperties){const i=this._$Eu(t,s);void 0!==i&&this._$Eh.set(i,t);}this.elementStyles=this.finalizeStyles(this.styles);}static finalizeStyles(s){const i=[];if(Array.isArray(s)){const e=new Set(s.flat(1/0).reverse());for(const s of e)i.unshift(c$3(s));}else void 0!==s&&i.push(c$3(s));return i}static _$Eu(t,s){const i=s.attribute;return  false===i?void 0:"string"==typeof i?i:"string"==typeof t?t.toLowerCase():void 0}constructor(){super(),this._$Ep=void 0,this.isUpdatePending=false,this.hasUpdated=false,this._$Em=null,this._$Ev();}_$Ev(){this._$ES=new Promise((t=>this.enableUpdating=t)),this._$AL=new Map,this._$E_(),this.requestUpdate(),this.constructor.l?.forEach((t=>t(this)));}addController(t){(this._$EO??=new Set).add(t),void 0!==this.renderRoot&&this.isConnected&&t.hostConnected?.();}removeController(t){this._$EO?.delete(t);}_$E_(){const t=new Map,s=this.constructor.elementProperties;for(const i of s.keys())this.hasOwnProperty(i)&&(t.set(i,this[i]),delete this[i]);t.size>0&&(this._$Ep=t);}createRenderRoot(){const t=this.shadowRoot??this.attachShadow(this.constructor.shadowRootOptions);return S$1(t,this.constructor.elementStyles),t}connectedCallback(){this.renderRoot??=this.createRenderRoot(),this.enableUpdating(true),this._$EO?.forEach((t=>t.hostConnected?.()));}enableUpdating(t){}disconnectedCallback(){this._$EO?.forEach((t=>t.hostDisconnected?.()));}attributeChangedCallback(t,s,i){this._$AK(t,i);}_$ET(t,s){const i=this.constructor.elementProperties.get(t),e=this.constructor._$Eu(t,i);if(void 0!==e&&true===i.reflect){const h=(void 0!==i.converter?.toAttribute?i.converter:u$2).toAttribute(s,i.type);this._$Em=t,null==h?this.removeAttribute(e):this.setAttribute(e,h),this._$Em=null;}}_$AK(t,s){const i=this.constructor,e=i._$Eh.get(t);if(void 0!==e&&this._$Em!==e){const t=i.getPropertyOptions(e),h="function"==typeof t.converter?{fromAttribute:t.converter}:void 0!==t.converter?.fromAttribute?t.converter:u$2;this._$Em=e,this[e]=h.fromAttribute(s,t.type)??this._$Ej?.get(e)??null,this._$Em=null;}}requestUpdate(t,s,i){if(void 0!==t){const e=this.constructor,h=this[t];if(i??=e.getPropertyOptions(t),!((i.hasChanged??f$3)(h,s)||i.useDefault&&i.reflect&&h===this._$Ej?.get(t)&&!this.hasAttribute(e._$Eu(t,i))))return;this.C(t,s,i);} false===this.isUpdatePending&&(this._$ES=this._$EP());}C(t,s,{useDefault:i,reflect:e,wrapped:h},r){i&&!(this._$Ej??=new Map).has(t)&&(this._$Ej.set(t,r??s??this[t]),true!==h||void 0!==r)||(this._$AL.has(t)||(this.hasUpdated||i||(s=void 0),this._$AL.set(t,s)),true===e&&this._$Em!==t&&(this._$Eq??=new Set).add(t));}async _$EP(){this.isUpdatePending=true;try{await this._$ES;}catch(t){Promise.reject(t);}const t=this.scheduleUpdate();return null!=t&&await t,!this.isUpdatePending}scheduleUpdate(){return this.performUpdate()}performUpdate(){if(!this.isUpdatePending)return;if(!this.hasUpdated){if(this.renderRoot??=this.createRenderRoot(),this._$Ep){for(const[t,s]of this._$Ep)this[t]=s;this._$Ep=void 0;}const t=this.constructor.elementProperties;if(t.size>0)for(const[s,i]of t){const{wrapped:t}=i,e=this[s];true!==t||this._$AL.has(s)||void 0===e||this.C(s,void 0,i,e);}}let t=false;const s=this._$AL;try{t=this.shouldUpdate(s),t?(this.willUpdate(s),this._$EO?.forEach((t=>t.hostUpdate?.())),this.update(s)):this._$EM();}catch(s){throw t=false,this._$EM(),s}t&&this._$AE(s);}willUpdate(t){}_$AE(t){this._$EO?.forEach((t=>t.hostUpdated?.())),this.hasUpdated||(this.hasUpdated=true,this.firstUpdated(t)),this.updated(t);}_$EM(){this._$AL=new Map,this.isUpdatePending=false;}get updateComplete(){return this.getUpdateComplete()}getUpdateComplete(){return this._$ES}shouldUpdate(t){return  true}update(t){this._$Eq&&=this._$Eq.forEach((t=>this._$ET(t,this[t]))),this._$EM();}updated(t){}firstUpdated(t){}};y$1.elementStyles=[],y$1.shadowRootOptions={mode:"open"},y$1[d$2("elementProperties")]=new Map,y$1[d$2("finalized")]=new Map,p$2?.({ReactiveElement:y$1}),(a$1.reactiveElementVersions??=[]).push("2.1.0");

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t$2=globalThis,i$3=t$2.trustedTypes,s$3=i$3?i$3.createPolicy("lit-html",{createHTML:t=>t}):void 0,e$3="$lit$",h$4=`lit$${Math.random().toFixed(9).slice(2)}$`,o$3="?"+h$4,n$2=`<${o$3}>`,r$2=document,l$1=()=>r$2.createComment(""),c$1=t=>null===t||"object"!=typeof t&&"function"!=typeof t,a=Array.isArray,u$1=t=>a(t)||"function"==typeof t?.[Symbol.iterator],d$1="[ \t\n\f\r]",f$2=/<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g,v=/-->/g,_=/>/g,m$1=RegExp(`>|${d$1}(?:([^\\s"'>=/]+)(${d$1}*=${d$1}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`,"g"),p$1=/'/g,g=/"/g,$=/^(?:script|style|textarea|title)$/i,y=t=>(i,...s)=>({_$litType$:t,strings:i,values:s}),x=y(1),T=Symbol.for("lit-noChange"),E=Symbol.for("lit-nothing"),A=new WeakMap,C=r$2.createTreeWalker(r$2,129);function P(t,i){if(!a(t)||!t.hasOwnProperty("raw"))throw Error("invalid template strings array");return void 0!==s$3?s$3.createHTML(i):i}const V=(t,i)=>{const s=t.length-1,o=[];let r,l=2===i?"<svg>":3===i?"<math>":"",c=f$2;for(let i=0;i<s;i++){const s=t[i];let a,u,d=-1,y=0;for(;y<s.length&&(c.lastIndex=y,u=c.exec(s),null!==u);)y=c.lastIndex,c===f$2?"!--"===u[1]?c=v:void 0!==u[1]?c=_:void 0!==u[2]?($.test(u[2])&&(r=RegExp("</"+u[2],"g")),c=m$1):void 0!==u[3]&&(c=m$1):c===m$1?">"===u[0]?(c=r??f$2,d=-1):void 0===u[1]?d=-2:(d=c.lastIndex-u[2].length,a=u[1],c=void 0===u[3]?m$1:'"'===u[3]?g:p$1):c===g||c===p$1?c=m$1:c===v||c===_?c=f$2:(c=m$1,r=void 0);const x=c===m$1&&t[i+1].startsWith("/>")?" ":"";l+=c===f$2?s+n$2:d>=0?(o.push(a),s.slice(0,d)+e$3+s.slice(d)+h$4+x):s+h$4+(-2===d?i:x);}return [P(t,l+(t[s]||"<?>")+(2===i?"</svg>":3===i?"</math>":"")),o]};class N{constructor({strings:t,_$litType$:s},n){let r;this.parts=[];let c=0,a=0;const u=t.length-1,d=this.parts,[f,v]=V(t,s);if(this.el=N.createElement(f,n),C.currentNode=this.el.content,2===s||3===s){const t=this.el.content.firstChild;t.replaceWith(...t.childNodes);}for(;null!==(r=C.nextNode())&&d.length<u;){if(1===r.nodeType){if(r.hasAttributes())for(const t of r.getAttributeNames())if(t.endsWith(e$3)){const i=v[a++],s=r.getAttribute(t).split(h$4),e=/([.?@])?(.*)/.exec(i);d.push({type:1,index:c,name:e[2],strings:s,ctor:"."===e[1]?H:"?"===e[1]?I:"@"===e[1]?L:k}),r.removeAttribute(t);}else t.startsWith(h$4)&&(d.push({type:6,index:c}),r.removeAttribute(t));if($.test(r.tagName)){const t=r.textContent.split(h$4),s=t.length-1;if(s>0){r.textContent=i$3?i$3.emptyScript:"";for(let i=0;i<s;i++)r.append(t[i],l$1()),C.nextNode(),d.push({type:2,index:++c});r.append(t[s],l$1());}}}else if(8===r.nodeType)if(r.data===o$3)d.push({type:2,index:c});else {let t=-1;for(;-1!==(t=r.data.indexOf(h$4,t+1));)d.push({type:7,index:c}),t+=h$4.length-1;}c++;}}static createElement(t,i){const s=r$2.createElement("template");return s.innerHTML=t,s}}function S(t,i,s=t,e){if(i===T)return i;let h=void 0!==e?s._$Co?.[e]:s._$Cl;const o=c$1(i)?void 0:i._$litDirective$;return h?.constructor!==o&&(h?._$AO?.(false),void 0===o?h=void 0:(h=new o(t),h._$AT(t,s,e)),void 0!==e?(s._$Co??=[])[e]=h:s._$Cl=h),void 0!==h&&(i=S(t,h._$AS(t,i.values),h,e)),i}class M{constructor(t,i){this._$AV=[],this._$AN=void 0,this._$AD=t,this._$AM=i;}get parentNode(){return this._$AM.parentNode}get _$AU(){return this._$AM._$AU}u(t){const{el:{content:i},parts:s}=this._$AD,e=(t?.creationScope??r$2).importNode(i,true);C.currentNode=e;let h=C.nextNode(),o=0,n=0,l=s[0];for(;void 0!==l;){if(o===l.index){let i;2===l.type?i=new R(h,h.nextSibling,this,t):1===l.type?i=new l.ctor(h,l.name,l.strings,this,t):6===l.type&&(i=new z(h,this,t)),this._$AV.push(i),l=s[++n];}o!==l?.index&&(h=C.nextNode(),o++);}return C.currentNode=r$2,e}p(t){let i=0;for(const s of this._$AV) void 0!==s&&(void 0!==s.strings?(s._$AI(t,s,i),i+=s.strings.length-2):s._$AI(t[i])),i++;}}class R{get _$AU(){return this._$AM?._$AU??this._$Cv}constructor(t,i,s,e){this.type=2,this._$AH=E,this._$AN=void 0,this._$AA=t,this._$AB=i,this._$AM=s,this.options=e,this._$Cv=e?.isConnected??true;}get parentNode(){let t=this._$AA.parentNode;const i=this._$AM;return void 0!==i&&11===t?.nodeType&&(t=i.parentNode),t}get startNode(){return this._$AA}get endNode(){return this._$AB}_$AI(t,i=this){t=S(this,t,i),c$1(t)?t===E||null==t||""===t?(this._$AH!==E&&this._$AR(),this._$AH=E):t!==this._$AH&&t!==T&&this._(t):void 0!==t._$litType$?this.$(t):void 0!==t.nodeType?this.T(t):u$1(t)?this.k(t):this._(t);}O(t){return this._$AA.parentNode.insertBefore(t,this._$AB)}T(t){this._$AH!==t&&(this._$AR(),this._$AH=this.O(t));}_(t){this._$AH!==E&&c$1(this._$AH)?this._$AA.nextSibling.data=t:this.T(r$2.createTextNode(t)),this._$AH=t;}$(t){const{values:i,_$litType$:s}=t,e="number"==typeof s?this._$AC(t):(void 0===s.el&&(s.el=N.createElement(P(s.h,s.h[0]),this.options)),s);if(this._$AH?._$AD===e)this._$AH.p(i);else {const t=new M(e,this),s=t.u(this.options);t.p(i),this.T(s),this._$AH=t;}}_$AC(t){let i=A.get(t.strings);return void 0===i&&A.set(t.strings,i=new N(t)),i}k(t){a(this._$AH)||(this._$AH=[],this._$AR());const i=this._$AH;let s,e=0;for(const h of t)e===i.length?i.push(s=new R(this.O(l$1()),this.O(l$1()),this,this.options)):s=i[e],s._$AI(h),e++;e<i.length&&(this._$AR(s&&s._$AB.nextSibling,e),i.length=e);}_$AR(t=this._$AA.nextSibling,i){for(this._$AP?.(false,true,i);t&&t!==this._$AB;){const i=t.nextSibling;t.remove(),t=i;}}setConnected(t){ void 0===this._$AM&&(this._$Cv=t,this._$AP?.(t));}}class k{get tagName(){return this.element.tagName}get _$AU(){return this._$AM._$AU}constructor(t,i,s,e,h){this.type=1,this._$AH=E,this._$AN=void 0,this.element=t,this.name=i,this._$AM=e,this.options=h,s.length>2||""!==s[0]||""!==s[1]?(this._$AH=Array(s.length-1).fill(new String),this.strings=s):this._$AH=E;}_$AI(t,i=this,s,e){const h=this.strings;let o=false;if(void 0===h)t=S(this,t,i,0),o=!c$1(t)||t!==this._$AH&&t!==T,o&&(this._$AH=t);else {const e=t;let n,r;for(t=h[0],n=0;n<h.length-1;n++)r=S(this,e[s+n],i,n),r===T&&(r=this._$AH[n]),o||=!c$1(r)||r!==this._$AH[n],r===E?t=E:t!==E&&(t+=(r??"")+h[n+1]),this._$AH[n]=r;}o&&!e&&this.j(t);}j(t){t===E?this.element.removeAttribute(this.name):this.element.setAttribute(this.name,t??"");}}class H extends k{constructor(){super(...arguments),this.type=3;}j(t){this.element[this.name]=t===E?void 0:t;}}class I extends k{constructor(){super(...arguments),this.type=4;}j(t){this.element.toggleAttribute(this.name,!!t&&t!==E);}}class L extends k{constructor(t,i,s,e,h){super(t,i,s,e,h),this.type=5;}_$AI(t,i=this){if((t=S(this,t,i,0)??E)===T)return;const s=this._$AH,e=t===E&&s!==E||t.capture!==s.capture||t.once!==s.once||t.passive!==s.passive,h=t!==E&&(s===E||e);e&&this.element.removeEventListener(this.name,this,s),h&&this.element.addEventListener(this.name,this,t),this._$AH=t;}handleEvent(t){"function"==typeof this._$AH?this._$AH.call(this.options?.host??this.element,t):this._$AH.handleEvent(t);}}class z{constructor(t,i,s){this.element=t,this.type=6,this._$AN=void 0,this._$AM=i,this.options=s;}get _$AU(){return this._$AM._$AU}_$AI(t){S(this,t);}}const Z={I:R},j=t$2.litHtmlPolyfillSupport;j?.(N,R),(t$2.litHtmlVersions??=[]).push("3.3.0");const B=(t,i,s)=>{const e=s?.renderBefore??i;let h=e._$litPart$;if(void 0===h){const t=s?.renderBefore??null;e._$litPart$=h=new R(i.insertBefore(l$1(),t),t,void 0,s??{});}return h._$AI(t),h};

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const s$2=globalThis;let i$2 = class i extends y$1{constructor(){super(...arguments),this.renderOptions={host:this},this._$Do=void 0;}createRenderRoot(){const t=super.createRenderRoot();return this.renderOptions.renderBefore??=t.firstChild,t}update(t){const r=this.render();this.hasUpdated||(this.renderOptions.isConnected=this.isConnected),super.update(t),this._$Do=B(r,this.renderRoot,this.renderOptions);}connectedCallback(){super.connectedCallback(),this._$Do?.setConnected(true);}disconnectedCallback(){super.disconnectedCallback(),this._$Do?.setConnected(false);}render(){return T}};i$2._$litElement$=true,i$2["finalized"]=true,s$2.litElementHydrateSupport?.({LitElement:i$2});const o$2=s$2.litElementPolyfillSupport;o$2?.({LitElement:i$2});(s$2.litElementVersions??=[]).push("4.2.0");

const classes$7 = {
  isLoading: 'is-loading'
};

class CollectionAppliedFilters extends i$2 {
  static properties = {
    filters: {
      type: Array
    },
    filterSettings: {
      type: Object
    },
    rangeMin: {
      type: Number
    },
    rangeMax: {
      type: Number
    },
    priceRangeComponent: {
      type: Object
    },
    resultCount: {
      type: Number
    },
    loading: {
      type: Boolean
    }
  }

  constructor () {
    super();
    this.rangeMin = 0;
    this.rangeMax = 1000;
    this.resultCount = 0;
    this.loading = false;
  }

  connectedCallback() {
    super.connectedCallback();
    const filterSettingsAttr = this.getAttribute('filter-settings');
    if (filterSettingsAttr) {
      this.filterSettings = JSON.parse(filterSettingsAttr);
    }
  }

  // Disable shadow Root
  createRenderRoot() {
    return this;
  }

  get haveAppliedFilter() {
    let haveAppliedFilter = false;
    this.filters?.forEach(filter => {
      if (filter.type === 'stats') {
        if (getParam('filter.price.min') || getParam('filter.price.max')) {
          haveAppliedFilter = true;
          this.haveAppliedPriceFilter = true;
        }
      } else if (filter.data.find(value => value.selected)) {
        haveAppliedFilter = true;
      }
    });
    return haveAppliedFilter && (!!this.rangeMin || this.rangeMin === 0) && (!!this.rangeMax || this.rangeMax === 0);
  }

  _renderXIcon() {
    return x`
      <span>
        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close applied-filter__icon" fill="none" viewBox="0 0 12 12">
          <path d="M1 1L11 11" stroke="currentColor" stroke-linecap="round" fill="none"></path>
          <path d="M11 1L1 11" stroke="currentColor" stroke-linecap="round" fill="none"></path>
        </svg>
      </span>
    `
  }

  _renderLoading() {
    return x`
      <div class="applied-filter__loading">
        <svg xmlns="http://www.w3.org/2000/svg"
             aria-hidden="true"
             focusable="false"
             class="icon icon-spinner"
             fill="none"
             viewBox="0 0 66 66">
          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
        </svg>
      </div>
    `
  }

  _renderCountResult() {
    if (!this.resultCount) return ''
    const resultMessage = getProductCountTitle(this.resultCount);
    return x`
      <div class="applied-filter__count-result ${this.loading ? classes$7.isLoading : ''}">
        <p class="applied-filter__count-text">
          ${resultMessage}
        </p>
        ${this._renderLoading()}
      </div>
    `
  }

  _renderAppliedFilters() {
    const initPriceRange = setInterval(() => {
      const container = document.querySelector('.cc-price-range');
      if (container && !container.classList.contains('cc-initialized')) {
        this.priceRangeComponent = new InitPriceRange(container);
        container.classList.add('cc-initialized');
      } else {
        clearInterval(initPriceRange);
      }
    }, 10);

    if (!this.haveAppliedFilter) return ''
    return x`
      <div class="applied-filter__items">
        <a class="decoration-none applied-filter__item applied-filter__clear-link pointer" @click="${() => this._handleFilterRemoveAll()}">
          ${this._renderXIcon()}
          <span>Clear all</span>
        </a>
        ${this.filters.map(filter => {
          if (filter.type === 'stats') {
            if (this.haveAppliedPriceFilter) {
              return x`
                <a class="decoration-none applied-filter__item pointer" @click="${() => this._handleFilterRemove(filter.field)}"">
                  ${this._renderXIcon()}
                  <span class="applied-filter__item-text">
                    ${getParam('filter.price.min') ? formatMoney(Number(getParam('filter.price.min'))) : formatMoney(this.rangeMin)} - ${getParam('filter.price.max') ? formatMoney(Number(getParam('filter.price.max'))) : formatMoney(this.rangeMax)}
                  </span>
                </a>
              `
            }
          } else {
            return x`
              ${filter.data.map(value => {
                if (value.selected) {
                  return x`
                    <a class="decoration-none applied-filter__item pointer" @click="${() => this._handleFilterRemove(filter.field, value.value)}">
                      ${this._renderXIcon()}
                      <span class="applied-filter__item-text">
                        ${filter.name}: ${convertFilterValue(value.value)}
                      </span>
                    </a>
                  `
                }
              })}
            `
          }
        })}
      </div>
    `
  }

  render () {
    return x`
      <div class="applied-filter">
        ${this._renderAppliedFilters()}
        ${this._renderCountResult()}
      </div>
    `
  }

  // Event handle filter remove
  _handleFilterRemove(field, value) {
    if (field === 'price') {
      removeParam('filter.price.min');
      removeParam('filter.price.max');
      this.haveAppliedPriceFilter = false;
    } else {
      removeParam(`filter.${field}`, value);
    }
    removeParam('page');
    const apiInput = convertParams();
    nostoGetProducts(apiInput.filter, apiInput.sort, apiInput.from);
    resetPriceRange(this.rangeMin, this.rangeMax);
    this.priceRangeComponent.controls.min.value = this.rangeMin;
    this.priceRangeComponent.controls.max.value = this.rangeMax;
  }

  // Event handle filter remove all
  _handleFilterRemoveAll() {
    const currentUrl = new URL(window.location.href);
    const searchQuery = getParam('q');
    currentUrl.search = '';
    this.haveAppliedPriceFilter = false;
    window.history.pushState({}, '', currentUrl);
    if (searchQuery) {
      setParam('q', searchQuery);
    }

    const DROPDOWN_BUTTON_TEXT_SELECTOR = '.link-dropdown__button-text';
    const UTILITY_BAR_RIGHT_SELECTOR = '.utility-bar__right';
    const DROPDOWN_LINK_SELECTOR = '.link-dropdown__link';
    const DROPDOWN_LINK_ACTIVE_SELECTOR = '.link-dropdown__link--active';

    const DROPDOWN_LINK_ACTIVE_CLASS = 'link-dropdown__link--active';

    const dropdownButtonText = document.querySelector(DROPDOWN_BUTTON_TEXT_SELECTOR);
    const linkDropdowns = Array.prototype.slice.call(document.querySelector(UTILITY_BAR_RIGHT_SELECTOR)?.querySelectorAll(DROPDOWN_LINK_SELECTOR) || []);
    const linkDropdownActive = document.querySelector(DROPDOWN_LINK_ACTIVE_SELECTOR);
    if (linkDropdownActive) {
      linkDropdownActive.classList.remove(DROPDOWN_LINK_ACTIVE_CLASS);
    }

    if (linkDropdowns.length) {
      linkDropdowns.map(linkDropdown => {
        const sortBy = linkDropdown.getAttribute('data-sort');
        if (sortBy === this.filterSettings.string?.collection_default_sort) {
          linkDropdown.classList.add(DROPDOWN_LINK_ACTIVE_CLASS);
          if (dropdownButtonText) {
            dropdownButtonText.innerText = linkDropdown.innerHTML;
          }
        }
      });
    }

    nostoGetProducts([], [], 0);
    resetPriceRange(this.rangeMin, this.rangeMax);
    this.priceRangeComponent.controls.min.value = this.rangeMin;
    this.priceRangeComponent.controls.max.value = this.rangeMax;
  }
}

customElements.define('collection-applied-filters', CollectionAppliedFilters);

/**
 * Creates a throttled function that limits the rate at which a function can fire.
 * @param {Function} callback - The function to throttle.
 * @param {number} [delay=50] - The number of milliseconds to delay.
 * @returns {Function} - The throttled function.
 */
const throttle = (callback, delay = 50) => {
  let timeoutId;
  return (...args) => {
    if (!timeoutId) {
      timeoutId = setTimeout(() => {
        timeoutId = null;
        callback(...args);
      }, delay);
    }
  };
};

/**
 * Handles a string by converting it to lowercase, trimming whitespace, and replacing special characters.
 * @param {string} str - The string to handle.
 * @returns {string} - The handled string.
 */
const handleString = (str) => {
  return str
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
};

/**
 * Detect if an element is sticky or not
 * @param {HTMLElement} element - The target element
 */
const observeSticky = (element) => {
  if (!element) return;
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.intersectionRatio < 1) {
        element.classList.add('is-sticky');
      } else {
        element.classList.remove('is-sticky');
      }
    },
    { threshold: [1] }
  );

  observer.observe(element);
};

const setScrollbarWidth = () => {
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
};

const currentSort$1 = getParam('sort_by') ?? '';

const classes$6 = {
  isLoading: 'is-loading',
  isActive: 'is-active'
};

class CollectionFilterSlideout extends i$2 {
  static properties = {
    filters: {
      type: Array
    },
    filterSettings: {
      type: Object
    },
    open: {
      type: Boolean
    },
    loading: {
      type: Boolean
    },
    firstLoad: {
      type: Boolean
    },
    resultCount: {
      type: Number
    },
    activeIndex: {
      type: Number
    }
  }

  constructor() {
    super();
    this.open = false;
    this._handleClose = this._handleClose.bind(this);
    this._handleOpen = this._handleOpen.bind(this);
    this._openGroup = this._openGroup.bind(this);
    this._renderFooter = this._renderFooter.bind(this);
    this.loading = false;
    this.resultCount = 0;
    this.activeIndex = -1;
    this.filterSettings = {};
  }

  connectedCallback() {
    super.connectedCallback();
    if (this.filterSettings?.enable_sticky) observeSticky(this);
  }

  // Disable shadow Root
  createRenderRoot() {
    return this;
  }

  _handleOpen() {
    this.open = true;
  }

  _handleClose() {
    this.activeIndex = -1;
    this.open = false;
  }

  _openGroup(index) {
    this.activeIndex = index;
  }

  _clearAllFilter(e) {
    e.preventDefault();
    const currentUrl = new URL(window.location.href);
    const searchQuery = getParam('q');
    currentUrl.search = '';
    window.history.pushState({}, '', currentUrl);
    if (searchQuery) {
      setParam('q', searchQuery);
    }
    const apiInput = convertParams();
    nostoGetProducts(apiInput.filter, apiInput.sort, apiInput.from);
  }

  _renderFooter() {
    return x`
      <footer class="filter-slideout__footer">
        <button class="button" type="button" @click="${this._handleClose}">Apply</button>
        <a class="link link--underline" href="#" @click="${this._clearAllFilter}">Clear</a>
      </footer>
    `
  }

  _renderFilters() {
    if (!this.filterSettings?.enable_filtering) return ''
    return x`
      ${this.filters?.map((filter, filterIndex) => {
        return x`
          <collection-filter-slideout-group
            .openGroup="${this._openGroup}"
            .filter="${filter}"
            .renderFooter="${this._renderFooter}"
            .active="${this.activeIndex === filterIndex}"
            .index="${filterIndex}"
          >
          </collection-filter-slideout-group>
        `
      })}
    `
  }

  _renderSort() {
    if (!this.filterSettings?.enable_sorting) return ''
    return x`
      <div class="filter-slideout__sort">
        <label class="uppercase" for="sort-by-mobile">Sort by</label>
        <div class="filter-slideout__sort-selections">
          <select class="select__select" name="sort_by" id="sort-by-mobile" @change="${(e) => {handleSortChange(e.target.value);}}">
            ${SORT_OPTIONS.map(sortOption => {
              const selected = currentSort$1.trim().toLowerCase() === sortOption.value.trim().toLowerCase();
              return x`
                <option ?selected="${selected}" value="${sortOption.value}">${sortOption.label}</option>
              `
            })}
          </select>
          <svg xmlns="http://www.w3.org/2000/svg"
               aria-hidden="true"
               focusable="false"
               class="icon icon-caret"
               fill="none"
               viewBox="0 0 24 15">
            <path fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12 15c-.3 0-.6-.1-.8-.4l-11-13C-.2 1.2-.1.5.3.2c.4-.4 1.1-.3 1.4.1L12 12.5 22.2.4c.4-.4 1-.5 1.4-.1.4.4.5 1 .1 1.4l-11 13c-.1.2-.4.3-.7.3z"
                  fill="currentColor"></path>
          </svg>
        </div>
      </div>
    `
  }

  _renderLoading() {
    return x`
      <div class="loading-overlay__spinner">
        <svg xmlns="http://www.w3.org/2000/svg"
             aria-hidden="true"
             focusable="false"
             class="icon icon-spinner"
             fill="none"
             viewBox="0 0 66 66">
          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
        </svg>
      </div>
    `
  }

  _renderBubble() {
    if (!this.filters) return ''
    let hasFilterSelected = false;

    outerLoop:
    for (const filter of this.filters) {
      const items = filter.data;
      for (const item of items) {
        if (item.selected) {
          hasFilterSelected = true;
          break outerLoop;
        }
      }
    }
    if (!hasFilterSelected) return '';
    return x`
      <span class="filter-slideout__bubble"></span>
    `
  }

  _getToggleButtonText() {
    if (this.filterSettings?.enable_sorting && this.filterSettings?.enable_filtering) return 'Filter and Sort'
    if (this.filterSettings?.enable_sorting) return 'Sort'
    if (this.filterSettings?.enable_filtering) return 'Filter'
    return ''
  }

  render() {
    if (!this.filters || !this.filters.length) return ''
    if (!this.filterSettings?.enable_sorting && !this.filterSettings?.enable_filtering) return ''
    const resultMessage = getProductCountTitle(this.resultCount);
    return x`
      <div class="filter-slideout">
        <button class="filter-slideout__toggle button button--secondary button--small button--full-width uppercase"
                type="button" @click="${this._handleOpen}">
          <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-filter"
               fill="none" viewBox="0 0 24 24">
            <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" fill="currentColor"></path>
          </svg>
          <span>${this._getToggleButtonText()}${this._renderBubble()}</span>
        </button>
      </div>
      <side-drawer .open="${this.open}" .position="${'right'}" .handleClose="${this._handleClose}">
        <section class="filter-slideout__drawer" slot="content">
          <div class="filter-slideout__header ${this.loading || this.firstLoad ? classes$6.isLoading : ''}">
            <p class="h2 center filter-slideout__title">Filter and Sort</p>
            ${resultMessage ? x`<p class="center filter-slideout__subtitle">${resultMessage}</p>` : ''}
            ${this._renderLoading()}
          </div>
          <div class="filter-slideout__main ${this.firstLoad ? classes$6.isLoading : ''}">
            ${this._renderFilters()}
            ${this._renderSort()}
            ${this._renderLoading()}
            ${this._renderFooter()}
          </div>
        </section>
      </side-drawer>
    `
  }
}

class CollectionFilterSlideoutGroup extends i$2 {
  static properties = {
    renderFooter: {},
    filter: {},
    openGroup: {},
    index: {},
    active: {}
  }

  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
  }

  protected

  createRenderRoot() {
    return this;
  }

  _handleOpenGroup() {
    this.openGroup(this.index);
  }

  _handleCloseGroup() {
    this.openGroup(-1);
  }

  render() {
    return x`
      <div class="filter-slideout__group ${this.active ? classes$6.isActive : ''}">
        <button class="uppercase button--plain button--full-width filter-slideout__group-toggle"
                type="button"
                @click="${this._handleOpenGroup}">
          <span>${this.filter.name}</span>
          <svg xmlns="http://www.w3.org/2000/svg"
               aria-hidden="true"
               focusable="false"
               class="icon icon-arrow"
               fill="none"
               viewBox="0 0 14 10">
            <path fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z"
                  fill="currentColor"></path>
          </svg>
        </button>
        <div class="filter-slideout__group-menu">
          <button class="filter-slideout__group-back button--plain button--full-width link link--text"
                  type="button"
                  @click="${this._handleCloseGroup}">
            <svg xmlns="http://www.w3.org/2000/svg"
                 aria-hidden="true"
                 focusable="false"
                 class="icon icon-arrow"
                 fill="none"
                 viewBox="0 0 14 10">
              <path fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z"
                    fill="currentColor"></path>
            </svg>
            <span class="uppercase">${this.filter.name}</span>
          </button>
          <div class="filter-slideout__group-list">
            <filter-list .filter="${this.filter}" .fromSlideout="${true}"></filter-list>
          </div>
          ${this.renderFooter()}
        </div>
      </div>
    `;
  }
}

customElements.define('collection-filter-slideout', CollectionFilterSlideout);
customElements.define('collection-filter-slideout-group', CollectionFilterSlideoutGroup);

class FilterAvailability extends i$2 {
  static properties = {
    filter: {}
  }

  constructor() {
    super();
  }

  // Disable shadow Root
  createRenderRoot() {
    return this;
  }

  render() {
    return x`
      <div class="filter-group filter-group--availability">
        <div class="filter-toggle filter-toggle--inline">
          <span class="filter-toggle__group-label">${this.filterSettings.string.filtering_out_of_stock}</span>
          <div class="filter-toggle__options">
            ${this.availability.map((value, index) => {
              let isInStock = true;
              if (!this.filter.data.find(filterValue => filterValue.value === 'InStock')?.selected) {
                isInStock = false;
              }
              let currentSelected = false;
              if ((value.value === 'InStock' && isInStock) || (value.value === 'OutOfStock' && !isInStock)) {
                currentSelected = true;
              }

              return x`
                <label
                  class="filter-toggle__input-label ${currentSelected ? 'filter-toggle__input--active' : ''}"
                  @click="${(event) => this._handleFilterChange(event, this.filter.field, value.value)}"
                >
                  <input class="filter-toggle__input"
                    id="Filter-${this.filter.field}-${index+1}"
                    type="radio"
                    name="${this.filter.field}"
                    value=""
                    ?checked="${currentSelected}"
                  >
                  <span class="filter-toggle__input-label-text">${index === 0 ? this.filterSettings.string.filtering_show : this.filterSettings.string.filtering_hide}</span>
                </label>
              `
            })}
          </div>
        </div>
      </div>
    `
  }

  // Event handle filter change
  _handleFilterChange(event, field, value) {
    event.preventDefault();
    removeParam('page');
    if (value === 'InStock') {
      removeParam(`filter.${field}`);
      const apiInput = convertParams();
      nostoGetProducts(apiInput.filter, apiInput.sort, apiInput.from);
    } else {
      if (getParam('q')) {
        setParam('type', 'product');
        setParam('options[prefix]', 'last');
      }
      setParam(`filter.${field}`, value);
      const apiInput = convertParams();
      nostoGetProducts(apiInput.filter, apiInput.sort, apiInput.from);
    }
  }
}

customElements.define('filter-availability', FilterAvailability);

const classes$5 = {
  shouldHide: 'should-hide',
  isExpanded: 'is-expanded'
};

const DEFAULT_MAX_ITEM_VISIBLE = 6;

class FilterList extends i$2 {
  static properties = {
    filter: {
      type: Object
    },
    filterSettings: {
      type: Object
    },
    fromSlideout: {
      type: Boolean
    },
    isExpanded: {
      type: Boolean,
      state: true
    }
  }

  constructor() {
    super();
    this.filterSettings = {};
    this.isExpanded = false;
    this.fromSlideout = false;
    this.maxItemVisible = this.filterSettings.filtering_max_items ?? DEFAULT_MAX_ITEM_VISIBLE;
  }

  // Disable shadow Root
  createRenderRoot() {
    return this;
  }

  updated(_changedProperties) {
    super.updated(_changedProperties);
    if (_changedProperties.has('isExpanded')) {
      this.classList.toggle(classes$5.isExpanded, this.isExpanded);
    }
  }

  render() {
    let shouldShowMoreLessBtn = false;
    return x`
      ${(this.filter?.data || []).map((value, index) => {
        shouldShowMoreLessBtn = (index >= this.maxItemVisible) && !this.fromSlideout; // Display all filter in slideout
        const filterItemLabel = convertFilterValue(value.value);
        if (value.count > 0 || value.selected) {
          return x`
            <label
              class="filter-group__item${value.selected ? ' filter-group__item--active' : ''}${value == 0 && !value.selected ? ' filter-group__item--disabled' : ''} ${shouldShowMoreLessBtn ? `${classes$5.shouldHide}` : ''}"
              @click="${(event) => this._handleFilterChange(event, this.filter.field, value.value, value.selected)}"
            >
              <input class="hidden"
                id="Filter-${this.filter.field}-${handleString(value.value)}"
                type="checkbox"
                name="${this.filter.field}"
                value="${value.value}"
                ?checked="${value.selected}"
                ?disabled="${value.count === 0 && !value.selected}"
              >
              <span class="filter-group__checkbox"></span>
              <span class="filter-group__item-text">
                ${filterItemLabel}
                ${!this.filter_group_is_swatch ? x`<span class="filter-group__item-count">(${value.count})</span>` : ''}
              </span>
            </label>
          `
        }
      })}
      ${shouldShowMoreLessBtn ? (
        x`
          <button class="button--plain filter-group__show-more-btn" @click="${this._handleClickShowMoreLessBtn}">
            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"
                 class="icon icon-horizontal-dots" fill="none" viewBox="0 0 20 20">
              <path
                d="M10.001 7.8c-1.215 0-2.201 0.985-2.201 2.2s0.986 2.2 2.201 2.2c1.215 0 2.199-0.985 2.199-2.2s-0.984-2.2-2.199-2.2zM3.001 7.8c-1.215 0-2.201 0.985-2.201 2.2s0.986 2.2 2.201 2.2c1.215 0 2.199-0.986 2.199-2.2s-0.984-2.2-2.199-2.2zM17.001 7.8c-1.215 0-2.201 0.985-2.201 2.2s0.986 2.2 2.201 2.2c1.215 0 2.199-0.985 2.199-2.2s-0.984-2.2-2.199-2.2z"
                fill="currentColor">
              </path>
            </svg>
          </button>
        `
      ) : ''}
    `
  }

  // Event handle filter change
  _handleFilterChange(event, field, value, selected) {
    removeParam('page');
    if (selected) {
      removeParam(`filter.${field}`, value);
      const apiInput = convertParams();
      nostoGetProducts(apiInput.filter, apiInput.sort, apiInput.from);
    } else {
      if (getParam('q')) {
        setParam('type', 'product');
        setParam('options[prefix]', 'last');
      }
      setParam(`filter.${field}`, value, true);
      const apiInput = convertParams();
      nostoGetProducts(apiInput.filter, apiInput.sort, apiInput.from);
    }
  }

  // Show more/less btn click handler
  _handleClickShowMoreLessBtn() {
    this.isExpanded = !this.isExpanded;
  }
}

customElements.define('filter-list', FilterList);

const classes$4 = {
  isExpanded: 'is-expanded'
};

class CollectionFilterVertical extends i$2 {
  static properties = {
    filters: {
      type: Array
    },
    filterSettings: {
      type: Object
    },
  }

  constructor () {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
  }

  // Disable shadow Root
  createRenderRoot() {
    return this;
  }

  _toggleExpanded(e) {
    e.preventDefault();
    const target = e.target.closest('[data-toggle-target]');
    if (!target) return;
    target.classList.toggle(classes$4.isExpanded);
  }

  render () {
    if (!this.filterSettings?.enable_filtering) return ''
    return x`
    ${this.filters?.map((filter, filterIndex) => {
      let filter_values_to_show_count = -1;
      filter.data.map(value => {
        if (value.count > 0 || value.selected) {
          filter_values_to_show_count += 1;
        }
      });

      const current_selected_count = filter.data.filter(value => value.selected).length;

      if (filter_values_to_show_count > 0) {
        return x`
          <div class="filter-group">
            <a href="#" class="filter-group__heading uppercase decoration-none ${classes$4.isExpanded}" data-toggle-target=".filter-group--${filterIndex + 1}" @click="${this._toggleExpanded}">
              <div class="filter-group__heading-text">
                <span>${filter.name}</span>
                <span class="filter-group__count-bubble ${current_selected_count > 0 ? '' : 'hidden'}">${current_selected_count}</span>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-care filter-group__heading-indicator" fill="none" viewBox="0 0 24 15">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M12 15c-.3 0-.6-.1-.8-.4l-11-13C-.2 1.2-.1.5.3.2c.4-.4 1.1-.3 1.4.1L12 12.5 22.2.4c.4-.4 1-.5 1.4-.1.4.4.5 1 .1 1.4l-11 13c-.1.2-.4.3-.7.3z" fill="currentColor"></path>
              </svg>
            </a>
            <div class="filter-group__items filter-group--${filterIndex + 1}">
              <div class="toggle-target-container">
                <filter-list .filter="${filter}" .filterSettings="${this.filterSettings}"></filter-list>
              </div>
            </div>
          </div>
        `
      }
    })}
    `
  }
}

customElements.define('collection-filter-vertical', CollectionFilterVertical);

const selectors$1 = {
  skeleton: '.js-collection-skeletons'
};

class CollectionFilter extends i$2 {
  static properties = {
    filters: {
      type: Array
    },
    filterSettings: {
      type: Object
    },
    firstLoad: {
      type: Boolean
    },
    loading: {
      type: Boolean
    },
    resultCount: {
      type: Number
    }
  }

  constructor() {
    super();
    this.firstLoad = true;
    this.loading = false;
  }

  connectedCallback() {
    super.connectedCallback();
    implementFilterSettings(this);
    this.skeletons = Array.from(this.querySelectorAll(selectors$1.skeleton));
  }

  // Disable shadow Root
  createRenderRoot() {
    return this;
  }

  renderFilterSlideout() {
    return x`
      <collection-filter-slideout
        .filters="${this.getRenderFilters()}"
        .filterSettings="${this.filterSettings}"
        .loading="${this.loading}"
        .firstLoad="${this.firstLoad}"
        .resultCount="${this.resultCount}"
      >
      </collection-filter-slideout>
    `
  }

  renderFilterVertical() {
    return x`
      <collection-filter-vertical .filters="${this.getRenderFilters()}" .filterSettings="${this.filterSettings}"></collection-filter-vertical>
    `
  }

  removeSkeleton() {
    if (!this.firstLoad && this.skeletons) {
      this.skeletons.forEach(skeleton => skeleton.remove());
    }
  }

  getRenderFilters() {
    if (!this.filters) return [];
    if (!this.filterSettings || !this.filterSettings.style_filter_excludes) return this.filters;
    return this.filters.map(filter => excludeFilterOptions(filter, 'Styles', this.filterSettings.style_filter_excludes));
  }

  render() {
    this.removeSkeleton();

    return x`
      ${this.renderFilterSlideout()}
      ${this.renderFilterVertical()}
    `
  }
}

customElements.define('collection-filter', CollectionFilter);

const GRID_LAYOUTS = [
  {
    cols: 2,
    mode: 'grid-2',
    icon: x`
     <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-grid-2" fill="none" viewBox="0 0 25 20" stroke-miterlimit="10">
      <line x1="1" y1="6.8" x2="5.6" y2="6.8"></line>
      <line x1="6.1" y1="1.7" x2="6.1" y2="6.3"></line>
      <line x1="12.5" y1="1.7" x2="12.5" y2="6.3"></line>
      <line x1="19" y1="1.7" x2="19" y2="6.3"></line>
      <line x1="6.1" y1="13.7" x2="6.1" y2="18.3"></line>
      <line x1="12.5" y1="13.7" x2="12.5" y2="18.3"></line>
      <line x1="19" y1="13.7" x2="19" y2="18.3"></line>
      <line x1="1" y1="13.3" x2="5.6" y2="13.3"></line>
      <line x1="19.5" y1="6.8" x2="24" y2="6.8"></line>
      <line x1="19" y1="13.3" x2="24" y2="13.3"></line>
      <rect x="6.1" y="6.8" width="6.5" height="6.5" stroke="currentColor"></rect>
      <rect x="12.5" y="6.8" width="6.5" height="6.5" stroke="currentColor"></rect>
    </svg>
    `
  },
  {
    cols: 3,
    mode: 'grid-3',
    icon: x`
     <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-grid-3" fill="none" viewBox="0 0 32 20" stroke-miterlimit="10">
      <line x1="1.3" y1="6.8" x2="5.8" y2="6.8"></line>
      <line x1="1.3" y1="13.3" x2="5.8" y2="13.3"></line>
      <line x1="6.3" y1="1.7" x2="6.3" y2="6.3"></line>
      <line x1="12.8" y1="1.7" x2="12.8" y2="6.3"></line>
      <line x1="19.2" y1="1.7" x2="19.2" y2="6.3"></line>
      <line x1="25.7" y1="1.7" x2="25.7" y2="6.3"></line>
      <line x1="6.3" y1="13.7" x2="6.3" y2="18.3"></line>
      <line x1="12.8" y1="13.7" x2="12.8" y2="18.3"></line>
      <line x1="19.2" y1="13.7" x2="19.2" y2="18.3"></line>
      <line x1="25.7" y1="13.7" x2="25.7" y2="18.3"></line>
      <line x1="26.2" y1="6.8" x2="30.7" y2="6.8"></line>
      <line x1="26.2" y1="13.3" x2="30.7" y2="13.3"></line>
      <rect x="6.3" y="6.8" width="6.5" height="6.5" stroke="currentColor"></rect>
      <rect x="12.8" y="6.8" width="6.5" height="6.5" stroke="currentColor"></rect>
      <rect x="19.2" y="6.8" width="6.5" height="6.5" stroke="currentColor"></rect>
    </svg>
    `
  },
  {
    cols: 4,
    mode: 'grid-4',
    icon: x`
     <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-grid-4" fill="none" viewBox="0 0 39 20" stroke-miterlimit="10">
      <line x1="1.5" y1="6.8" x2="6" y2="6.8"></line>
      <line x1="1.5" y1="13.3" x2="6" y2="13.3"></line>
      <line x1="6.5" y1="1.7" x2="6.5" y2="6.3"></line>
      <line x1="13" y1="1.7" x2="13" y2="6.3"></line>
      <line x1="19.5" y1="1.7" x2="19.5" y2="6.3"></line>
      <line x1="26" y1="1.7" x2="26" y2="6.3"></line>
      <line x1="32.5" y1="1.7" x2="32.5" y2="6.3"></line>
      <line x1="6.5" y1="13.7" x2="6.5" y2="18.3"></line>
      <line x1="13" y1="13.7" x2="13" y2="18.3"></line>
      <line x1="19.5" y1="13.7" x2="19.5" y2="18.3"></line>
      <line x1="26" y1="13.7" x2="26" y2="18.3"></line>
      <line x1="32.5" y1="13.7" x2="32.5" y2="18.3"></line>
      <line x1="33" y1="6.8" x2="37.5" y2="6.8"></line>
      <line x1="33" y1="13.3" x2="37.5" y2="13.3"></line>
      <rect x="6.5" y="6.8" width="6.5" height="6.5" stroke="currentColor"></rect>
      <rect x="13" y="6.8" width="6.5" height="6.5" stroke="currentColor"></rect>
      <rect x="19.5" y="6.8" width="6.5" height="6.5" stroke="currentColor"></rect>
      <rect x="26" y="6.8" width="6.5" height="6.5" stroke="currentColor"></rect>
    </svg>
    `
  }
];

const currentSort = getParam('sort_by') ?? '';

const classes$3 = {
  isLoading: 'is-loading'
};

class CollectionFilterToolbar extends i$2 {
  static properties = {
    gridView: {
      type: String
    },
    resultCount: {
      type: Number
    },
    loading: {
      type: Boolean
    },
    sectionSettings: {
      type: Object
    },
    label: {
      type: String
    }
  }

  constructor() {
    super();
    this.gridViewKey = 'beyours:collection-layout';
    this.gridView = '';
    this.filterSettings = {};
    this.selectors = {
      productList: '.js-product-list'
    };
    this.resultCount = 0;
    this.loading = false;
    this._updateSortLabel();
  }

  connectedCallback() {
    super.connectedCallback();
    implementFilterSettings(this);
    implementSearchSectionSettings(this);
    this.defaultGridView = this._getDefaultGridView();

    document.addEventListener('DOMContentLoaded', () => {
      this.gridView = this.defaultGridView;
    }, { once: true });
  }

  // Disable shadow Root
  createRenderRoot() {
    return this;
  }

  _renderSort() {
    if (!this.filterSettings?.enable_sorting) return ''
    const selectedSort = SORT_OPTIONS.findIndex(option => option.value === currentSort);
    return x`
      <input-dropdown
        .options="${SORT_OPTIONS}"
        .selectedIndex="${selectedSort < 0 ? 0 : selectedSort}"
        .name="${'sort_by'}"
        .onChange="${(e) => {
          handleSortChange(e.target.value);
          this._updateSortLabel();
        }}"
        .label="${this.label}"
      >
      </input-dropdown>
    `
  }


  // Keep this feature for future use
  _renderLayoutSwitcher() {
    if (!this.filterSettings?.enable_viewing) return ''
    return x`
      <ul class="grid-layout">
        ${GRID_LAYOUTS.map(layout => {
          const isActive = layout.mode === this.gridView;
          return x`
            <li>
              <button
                class="button--plain grid-layout__view ${isActive ? 'grid-layout__view--active' : ''}"
                type="button"
                data-layout-mode="${layout.mode}"
                @click="${() => {
                  this._handleChangeLayout(layout.mode);
                }}"
              >
                <span class="grid-layout__view-content">
                  ${layout.icon}
                  <i class="grid-layout__view-col">${layout.cols}</i>
                </span>
              </button>
            </li>
          `
        })}
      </ul>
    `
  }

  _handleChangeLayout(mode) {
    this.gridView = mode;
    window.localStorage.setItem(this.gridViewKey, mode);
  }

  _renderLoading() {
    return x`
      <div class="applied-filter__loading">
        <svg xmlns="http://www.w3.org/2000/svg"
             aria-hidden="true"
             focusable="false"
             class="icon icon-spinner"
             fill="none"
             viewBox="0 0 66 66">
          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
        </svg>
      </div>
    `
  }

  // Keep this function for future use
  _renderCountResult() {
    if (!this.resultCount) return ''
    const resultMessage = getProductCountTitle(this.resultCount);
    return x`
      <div class="applied-filter__count-result ${this.loading ? classes$3.isLoading : ''}">
        <p class="applied-filter__count-text">
          ${resultMessage}
        </p>
        ${this._renderLoading()}
      </div>
    `
  }

  _getDefaultGridView() {
    const productsPerRow = this.sectionSettings?.products_per_row ?? 4;
    return window.localStorage.getItem(this.gridViewKey) ?? `grid-${productsPerRow}`;
  }

  updated(_changedProperties) {
    super.updated(_changedProperties);
    if (_changedProperties.has('gridView')) {
      const productListElement = document.querySelector(this.selectors.productList);
      if (productListElement) {
        const prefix = 'product-list--';
        const removedClass = prefix + _changedProperties.get('gridView');
        const addedClass = prefix + this.gridView;
        productListElement.classList.remove(removedClass);
        productListElement.classList.add(addedClass);
      }
    }
  }

  _updateSortLabel() {
    this.label = getSortLabel() ?? 'Sort by';
  }

  render() {
    if (!this.filterSettings?.enable_sorting && !this.filterSettings?.enable_viewing) return ''
    return x`
      <div class="filter-toolbar small-hide">
        ${this._renderSort()}
        ${this._renderLayoutSwitcher()}
      </div>
    `;
  }
}

customElements.define('collection-filter-toolbar', CollectionFilterToolbar);

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t$1={CHILD:2},e$2=t=>(...e)=>({_$litDirective$:t,values:e});let i$1 = class i{constructor(t){}get _$AU(){return this._$AM._$AU}_$AT(t,e,i){this._$Ct=t,this._$AM=e,this._$Ci=i;}_$AS(t,e){return this.update(t,e)}update(t,e){return this.render(...e)}};

/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const {I:t}=Z,e$1=(o,t)=>void 0!==o?._$litType$,l=o=>null!=o?._$litType$?.h,f$1=o=>void 0===o.strings,s$1=()=>document.createComment(""),r$1=(o,i,n)=>{const e=o._$AA.parentNode,l=o._$AB;if(void 0===n){const i=e.insertBefore(s$1(),l),c=e.insertBefore(s$1(),l);n=new t(i,c,o,o.options);}else {const t=n._$AB.nextSibling,i=n._$AM,c=i!==o;if(c){let t;n._$AQ?.(o),n._$AM=o,void 0!==n._$AP&&(t=o._$AU)!==i._$AU&&n._$AP(t);}if(t!==l||c){let o=n._$AA;for(;o!==t;){const t=o.nextSibling;e.insertBefore(o,l),o=t;}}}return n},u={},m=(o,t=u)=>o._$AH=t,p=o=>o._$AH,h$3=o=>{o._$AR();};

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const d=t=>l(t)?t._$litType$.h:t.strings,h$2=e$2(class extends i$1{constructor(t){super(t),this.et=new WeakMap;}render(t){return [t]}update(s,[e]){const u=e$1(this.it)?d(this.it):null,h=e$1(e)?d(e):null;if(null!==u&&(null===h||u!==h)){const e=p(s).pop();let o=this.et.get(u);if(void 0===o){const s=document.createDocumentFragment();o=B(E,s),o.setConnected(false),this.et.set(u,o);}m(o,[e]),r$1(o,void 0,e);}if(null!==h){if(null===u||u!==h){const t=this.et.get(h);if(void 0!==t){const i=p(t).pop();h$3(s),r$1(s,void 0,i),m(s,[i]);}}this.it=e;}else this.it=void 0;return this.render(e)}});

/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const i=e$2(class extends i$1{constructor(){super(...arguments),this.key=E;}render(r,t){return this.key=r,t}update(r,[t,e]){return t!==this.key&&(m(r),this.key=t),e}});

class ProductRatingStar extends i$2 {
  static get properties() {
    return {
      ratingCount: 0,
      scaleMax: 5,
    };
  }

  constructor() {
    super();
  }

  // Disable shadow Root
  createRenderRoot() {
    return this;
  }

  render() {
    return x`
      <div
        class="rating"
        role="img"
        aria-label="${this.ratingCount}"
      >
        <span
          aria-hidden="true"
          class="rating-star"
          style="--rating: ${this.ratingCount}; --rating-max: ${this.scaleMax}; --rating-decimal: 0;"
        ></span>
      </div>
    `;
  }
}

customElements.define("product-rating-star", ProductRatingStar);

class ProductCard extends i$2 {
  static get properties() {
    return {
      product: { type: Object },
      enable_quick_view: false,
      section_settings: {},
      search_products_list: false,
      price: {
        attribute: 'data-price'
      },
      compareAtPrice: {
        attribute: 'data-compare-at-price'
      },
      loading: {
        type: Boolean
      }
    };
  }
  constructor() {
    super();
    this.loading = true;
    this.section_settings = {};
    const productAttr = this.getAttribute('product');
    if (productAttr && typeof productAttr === 'string') {
      this.setAttribute('product', this._formatJsonAttribute(productAttr));
    }
  }

  convertUrl (imageUrl) {
    const urlParts = imageUrl.split('?');
    const baseUrl = urlParts[0];
    const queryString = urlParts[1] ? "?" + urlParts[1] : "";
    const extensionMatch = baseUrl.match(/\.\w+$/);
    const extension = extensionMatch ? extensionMatch[0] : '';
    return baseUrl.replace(extension, `_{width}x${extension}`) + queryString;
  }

  getCustomFieldByKey (key) {
    const field = this.product.customFields.find((field) => field.key === key);
    return field ? field.value : null
  }

  getImageClasses() {
    const { image_ratio } = this.section_settings;

    const ratioClassMap = {
      square: "media--square",
      portrait: "media--portrait",
      landscape: "media--landscape",
      cropped: "media--cropped",
      wide: "media--wide",
      circle: "media--circle",
    };

    return ratioClassMap[image_ratio] || "media--portrait";
  }

  getImageStyles() {
    const { image_position, enable_image_fill } = this.section_settings;

    return {
      objectPosition: image_position || "center center",
      objectFit: enable_image_fill ? "cover" : "contain",
    };
  }

  updateImage() {
    const images = Array.from(this.querySelectorAll("img"));
    if (images.length) {
      images.forEach(img => {
        // Remove the lazyloaded class to allow reprocessing
        img.classList.remove('lazyloaded');

        // Trigger lazysizes to re-evaluate the image
        window.lazySizes.loader.unveil(img);
      });
    }
  }

  updated (changedProperties) {
    if (changedProperties.has('product')) {
      this.updateImage();
      this._resetVariantSwatchKing();
      this.dispatchEvent(new CustomEvent('vsk:product:changed', {
        detail: {
          handle: this.product.url
            .split('/products/')[1]
            .split('/')[0]
            .split('?')[0]
        },
        bubbles: true,
        cancelable: false
      }));
    }
  }

  connectedCallback() {
    super.connectedCallback();
    const productAttr = this.getAttribute('product');
    const product = productAttr && typeof productAttr === 'string' ? JSON.parse(productAttr) : this.product;
    this.product = product;
    this.price = product.price ? product.price * 100 : 0;
    this.compareAtPrice = product.listPrice ? product.listPrice * 100 : 0;
  }

  // Disable shadow Root
  createRenderRoot() {
    return this;
  }

  _resetVariantSwatchKing() {
    const variantSwatchKingElement = this.querySelector('variant-swatch-king');
    if (!variantSwatchKingElement) return;
    variantSwatchKingElement.remove();
    this.vsk_initialized = undefined;
  }

  _handleWishlistButton(e) {
    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('swym:collections-loaded'));
    }, 1000);
  }

  _formatJsonAttribute(jsonValue = '') {
    let result = jsonValue.replace(/"/g, '\\"');
    return result.replace(/`/g, '"');
  }


  render () {
    const productAttr = this.getAttribute('product');
    const product = productAttr && typeof productAttr === 'string' ? JSON.parse(productAttr) : this.product;

    const settings = typeof this.section_settings === 'string' ? JSON.parse(this.section_settings) : this.section_settings;

    const showSecondaryImage = settings.show_secondary_image;
    const secondaryImageUrl = product?.secondaryImageUrl ?? product?.alternateImageUrls?.[0] ?? '';

    const showVendor = settings.show_vendor;
    const showRating = settings.show_rating;
    const showQuickBuy = settings.show_quick_buy;
    const enableQuickView = settings.enable_quick_view;
    const enableColorSwatches = settings.enable_color_swatches;

    const imageStyles = this.getImageStyles();

    const ratingItem = product.customFields?.find(
      (item) => item.key === "reviews-rating"
    );

    const ratingData = ratingItem ? JSON.parse(ratingItem.value) : null;

    const ratingValue = ratingData ? Math.floor(parseFloat(ratingData.value)) : 0;
    const scaleMax = ratingData ? parseFloat(ratingData.scale_max) : 5;

    return x`
      <div
        class="
          product-card__wrapper
          card-wrapper
          ${!enableColorSwatches && this.search_products_list
            ? "disable-color-swatches"
            : ""
          }
          ${this.loading ? 'loading' : ''}
        "
      >
        <use-animate class="card product-card__product" data-animate="zoom-fade-small" animate>
          <a
            class="product-card__media media-wrapper"
            href="${product.url}"
            aria-label="${product.name}"
            tabindex="-1"
          >
            <div
              class="card--image-animate image-animate media media--hover-effect ${this.getImageClasses()}"
              style="
                --img-object-fit: ${this.search_products_list && imageStyles.objectFit};
                --img-object-position: ${this.search_products_list && imageStyles.objectPosition};
              "
            >
              <picture is="prog-picture" class="motion-reduce">
                <img
                  class="lazyload product-card__image"
                  data-src="${this.convertUrl(product.imageUrl)}"
                  data-widths="[180, 220, 300, 360, 460, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]"
                  data-aspectratio="1.0"
                  data-sizes="auto"
                  alt="${product.name}"
                />
              </picture>
              ${showSecondaryImage && secondaryImageUrl ? x`
                <picture is="prog-picture" class="motion-reduce">
                  <span></span> <!-- Add an empty element to match variant swatch king secondary image selector -->
                  <img
                    class="lazyload product-card__image product-card__secondary-image"
                    data-src="${this.convertUrl(secondaryImageUrl)}"
                    data-widths="[180, 220, 300, 360, 460, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]"
                    data-aspectratio="1.0"
                    data-sizes="auto"
                    alt="${product.name}"
                  />
                </picture>`
                : ''}
            </div>
          </a>
          <button
            aria-label="Add to Wishlist"
            data-with-epi="true"
            class="product-card__swym-button swym-button swym-add-to-wishlist-view-product swym-inject product_${product.productId} js-swym-button"
            data-swaction="addToWishlist"
            data-product-id="${product.productId}"
            data-variant-id="${product.skus[0].id}"
            data-product-url="${product.url}"
            @click="${this._handleWishlistButton}"
          >
          </button>
        </use-animate>

        <div class="product-card__information">
          <div class="product-card__button-wrapper">
            <div class="product-card-information__top">
              <span class="visually-hidden"></span>
              <div class="product-card__vendor ${!showVendor && this.search_products_list ? 'hidden-section' : ''}">
                ${product.brand}
              </div>
            </div>
            <a
              class="product-card__information-text card-information__text h4 product-card__product-title js-product-link"
              href="${product.url}"
              >${product.name}</a
            >
            <span class="caption-large light"></span>
            <div class="product-card__prices price">
              ${this.compareAtPrice && this.compareAtPrice > this.price ?
                x`
                  <span
                    class="product-card__price-compare js-product-card-compare-price"
                    data-product-id="${product.productId}"
                    data-product-url="${product.url}"
                  >
                    <bdi>
                      ${formatMoney(this.compareAtPrice)}
                    </bdi>
                  </span>`
                : ''}
              <span
                class="product-card__price js-product-card-price"
                data-product-id="${product.productId}"
                data-product-url="${product.url}"
              >
                ${formatMoney(this.price)}
              </span>
            </div>
            ${ratingValue > 0
              ? x`
                <product-rating-star
                  class="${showRating || !this.search_products_list ? '' : 'hidden-section'}"
                  scaleMax="${scaleMax}"
                  ratingCount="${ratingValue}"
                ></product-rating-star>
                `
              : ""}
          </div>
          <div class="product-card__information-button">
            <quick-view-button
              class="button button--small product-card__preview-button ${!showQuickBuy && this.search_products_list ? 'hidden-section' : ''}"
              data-product-url="${product.url}"
            >
              Choose options
              <svg
                class="icon icon-cart product-card__preview-icon"
                aria-hidden="true"
                focusable="false"
              >
                <use href="#icon-cart"></use>
              </svg>
            </quick-view-button>
          </div>
        </div>
        ${this.compareAtPrice && this.compareAtPrice > this.price
          ? x`
              <div class="product-card__badge">
                <span class="product-card__badge-text badge">
                  -${Math.round((1 - this.price / this.compareAtPrice) * 100)}%
                </span>
              </div>
            `
          : ''
        }
        <quick-view-drawer class="${enableQuickView || !this.search_products_list ? '' : 'hidden-section'}">
          <details>
            <summary class="quick-view__summary" tabindex="-1">
              <span class="visually-hidden">${product.name}</span>
            </summary>
            <quick-view
              class="quick-view"
              data-product-url="${product.url}"
            >
              <div
                role="dialog"
                aria-label="${product.name}"
                aria-modal="true"
                class="quick-view__content"
                tabindex="-1"
              ></div>
            </quick-view>
          </details>
        </quick-view-drawer>
      </div>
    `
  }
}

customElements.define('product-card', ProductCard);

class ProductSkeleton extends i$2 {
  constructor() {
    super();
  }

  // Disable shadow Root
  createRenderRoot() {
    return this;
  }

  render() {
    return x`
      <div class="search-result search-product__skeletons js-collection-skeletons">
        <div class="search-product__skeleton">
          <div class="skeleton search-product__skeleton"></div>
        </div>
      </div>
    `
    }
}

customElements.define('product-skeleton', ProductSkeleton);

const query = getParam('q') ?? '';

class CollectionListing extends i$2 {
  static properties = {
    sectionSettings: {},
    settings: {},
    string: {},
    products: {},
    firstLoading: true,
    loading: true,
    enable_quick_view: false
  }

  constructor () {
    super();
    this.gridViewKey = 'beyours:collection-layout';
    this.products = [];
    this.firstLoading = true;
    this.loading = true;
  }

  connectedCallback() {
    super.connectedCallback();

    implementSearchSectionSettings(this);
    implementProductSettings(this);

    const settingsAttr = this.getAttribute('settings');
    if (settingsAttr) {
      this.settings = JSON.parse(settingsAttr);
    }

    const stringAttr = this.getAttribute('string');
    if (stringAttr) {
      this.string = JSON.parse(stringAttr);
    }
  }

  // Disable shadow Root
  createRenderRoot() {
    return this;
  }

  render () {
    const productsPerPage = this.sectionSettings?.products_per_page || 24;
    const columnsMobile = this.sectionSettings?.columns_mobile || 2;
    let skeletonArr = new Array(productsPerPage).fill(3);

    const renderSkeletons = () => skeletonArr.map(element =>
      x`<product-skeleton .element="${element}" class="product-card nosto-loading"></product-skeleton>`
    );

    const renderProducts = () => this.products.map(product => {
      return i(this.products, h$2(x`
        <product-card
          .product="${product}"
          data-product-id="${product.productId}"
          data-variant-id="${product.skus[0].id}"
          data-product-url="${product.url}"
          .section_settings="${this.productSettings}"
          enable_quick_view="${this.enable_quick_view}"
          search_products_list="${true}"
          class="product-card grid__item js-product-card">
        </product-card>`)
      );
    });

    const renderContent = () => {
      if (!this.firstLoading && !this.products.length) {
        return x`
          <div class="template-search__empty">
            <h2 class="template-search__empty-heading">
              ${this.string.product_no_matches.replace('{{ terms }}', query)}
            </h2>
            <p class="h2 template-search__empty-text">
              ${this.string.check_the_spelling}
            </p>
          </div>
        `;
      }

      const productsPerRow = this.sectionSettings.products_per_row ?? 4;
      const defaultGrid = window.localStorage.getItem(this.gridViewKey) ?? `grid-${productsPerRow}`;

      return x`
        <div class="
          search-products-list
          product-list product-list--per-row-${this.sectionSettings.grid}
          product-list--per-row-mob-2
          product-list--image-shape-2
          product-list--${defaultGrid}
          product-list--mobile-col-${columnsMobile}
          product-grid
          js-product-list"
        >
          ${this.firstLoading ? renderSkeletons() : renderProducts()}
        </div>
      `;
    };

    return x`
      <div class="filters-adjacent collection-listing ${this.loading ? 'is-loading' : ''}">
        ${renderContent()}
      </div>
    `;
  }
}

customElements.define('collection-listing', CollectionListing);

const paginationParts = (currentPage, pages) => {
  const parts = [];
  if (pages >= 2) {
    if (pages <= 4) {
      for (let i = 1; i <= pages; i++) {
        parts.push({
          title: i,
          disabled: false,
        });
      }
    } else {
      if (currentPage <= 4) {
        for (let i = 1; i <= currentPage + 2; i++) {
          parts.push({
            title: i,
            disabled: false,
          });
        }
        parts.push({
          title: '...',
          disabled: true,
        });
        parts.push({
          title: pages,
          disabled: false,
        });
      } else {
        if (pages <= 8) {
          parts.push({
            title: 1,
            disabled: false,
          });
          parts.push({
            title: '...',
            disabled: true,
          });
          for (let i = 3; i <= pages; i++) {
            parts.push({
              title: i,
              disabled: false,
            });
          }
        } else {
          if (currentPage <= pages - 4) {
            parts.push({
              title: 1,
              disabled: false,
            });
            parts.push({
              title: '...',
              disabled: true,
            });
            for (let i = currentPage - 2; i <= currentPage + 2; i++) {
              parts.push({
                title: i,
                disabled: false,
              });
            }
            parts.push({
              title: '...',
              disabled: true,
            });
            parts.push({
              title: pages,
              disabled: false,
            });
          } else {
            parts.push({
              title: 1,
              disabled: false,
            });
            parts.push({
              title: '...',
              disabled: true,
            });
            for (let i = pages - 5; i <= pages; i++) {
              parts.push({
                title: i,
                disabled: false,
              });
            }
          }
        }
      }
    }
  } else {
    parts.push({
      title: 1,
      disabled: false,
    });
  }

  return parts
};

class CollectionPagination extends i$2 {
  static properties = {
    pagination: {},
    string: {},
    loading: true
  }

  constructor() {
    super();
    this.pagination = {};
    this.loading = true;
  }

  connectedCallback() {
    super.connectedCallback();
    const stringAttr = this.getAttribute('string');
    if (stringAttr) {
      this.string = JSON.parse(stringAttr);
    }
    }

  // Disable shadow Root
  createRenderRoot() {
    return this;
  }

  render() {
    if (!this.loading) {
      const pages = Math.ceil(this.pagination.total / this.pagination.size);
      const currentPage = this.pagination.from / this.pagination.size + 1;
      const parts = paginationParts(currentPage, pages);

      if (pages > 1) {
        return x`
          <div class="container pagination-row">
            <div class="pagination">
              ${currentPage > 1 ? x`
                <a class="prev pointer" @click="${() => this._handlePageChange(currentPage-1)}">${this.string.pagination_previous}</a>
              ` : ''}

              ${parts.map(part => {
                return x`
                  <span class="pagination__number decoration-none pointer${currentPage === part.title ? ' active' : ''}${part.disabled ? ' disabled' : ''}"
                  @click="${part.disabled ? E : () => this._handlePageChange(part.title)}">
                    ${part.title}
                  </span>
                `
              })}

              ${currentPage < pages ? x`
                <a class="next pointer" @click="${() => this._handlePageChange(currentPage+1)}">${this.string.pagination_next}</a>
              ` : ''}
            </div>
          </div>
        `
      }
    }
  }

  _handlePageChange(page) {
    setParam('page', page, false);
    const apiInput = convertParams();
    nostoGetProducts(apiInput.filter, apiInput.sort, apiInput.from).then(() => {
      window.scroll({
        top: 0,
        behavior: 'smooth'
      });
    });
  }
}

customElements.define('collection-pagination', CollectionPagination);

const COLLECTION_LISTING_SELECTOR = 'collection-listing';
const UTILITY_BAR_RIGHT_SELECTOR = '.utility-bar__right';
const DROPDOWN_LINK_SELECTOR = '.link-dropdown__link';
const DROPDOWN_LINK_ACTIVE_SELECTOR = '.link-dropdown__link--active';
const DROPDOWN_BUTTON_TEXT_SELECTOR = '.link-dropdown__button-text';

const DROPDOWN_LINK_ACTIVE_CLASS = 'link-dropdown__link--active';

const collectionGrid = () => {
  let collectionDefaultSort = '';
  const collectionListing = document.querySelector(COLLECTION_LISTING_SELECTOR);
  if (collectionListing) {
    const collectionAttr = collectionListing.getAttribute('collection');
    if (collectionAttr) {
      collectionDefaultSort = JSON.parse(collectionAttr).default_sort;
    }
  }
  const sortParam = getParam('sort_by');
  const apiInput = convertParams();

  nostoGetProducts(apiInput.filter, apiInput.sort, apiInput.from, false);

  /**
   * Handle filter change
   * This function should be used to handle sort-by dropdown change
   * Send a request to Nosto API to get the updated products
   * element: .utility-bar__right
   */

  const handleSortByChange = () => {
    const dropdownButtonText = document.querySelector(DROPDOWN_BUTTON_TEXT_SELECTOR);
    const linkDropdowns = Array.prototype.slice.call(document.querySelector(UTILITY_BAR_RIGHT_SELECTOR)?.querySelectorAll(DROPDOWN_LINK_SELECTOR) || []);
    if (linkDropdowns.length) {
      linkDropdowns.map(linkDropdown => {
        // set init state when page reload
        const sortBy = linkDropdown.getAttribute('data-sort');
        const isSortParamMatch = sortParam && sortBy === sortParam;
        const isDefaultSortMatch = !sortParam && sortBy === collectionDefaultSort;

        if (isSortParamMatch || isDefaultSortMatch) {
          linkDropdown.classList.add(DROPDOWN_LINK_ACTIVE_CLASS);
          if (dropdownButtonText) {
            dropdownButtonText.innerText = linkDropdown.innerHTML;
          }
        }

        const href = linkDropdown.getAttribute('href');
        const revertHref = () => {
          linkDropdown.setAttribute('href', href);
        };

        // set state when click sort by button
        linkDropdown.addEventListener('click', () => {
          linkDropdown.removeAttribute('href');
          const linkDropdownActive = document.querySelector(DROPDOWN_LINK_ACTIVE_SELECTOR);
          if (linkDropdownActive) {
            linkDropdownActive.classList.remove(DROPDOWN_LINK_ACTIVE_CLASS);
          }
          if (dropdownButtonText) {
            dropdownButtonText.innerText = linkDropdown.innerHTML;
          }
          linkDropdown.classList.add(DROPDOWN_LINK_ACTIVE_CLASS);
          setParam('sort_by', sortBy, false);
          const apiInput = convertParams();
          nostoGetProducts(apiInput.filter, apiInput.sort, apiInput.from, true, false, revertHref);
        });
      });
    }
  };

  handleSortByChange();
};

async function getSearchResults(key) {
  nostojs((api) => {
    api.recordSearchClick('autocomplete', { keyword: key });
  });
  return new Promise((resolve, reject) => {
    nostojs(function (api) {
      api
        .search(
          {
            query: key || null,
            products: {
              facets: ["*"],
              fields: NOSTO_FIELDS,
              size: 6
            },
            keywords: { size: 6 }
          },
          {
            redirect: true,
            track: 'serp'
          }
        )
        .then(function (response) {
          resolve({ data: { search: response }});
        })
        .catch(function (error) {
          reject(error);
        });
    });
  })
}

const suggestionMark = (input, suggestion) => {
  const container = document.createElement('span');
  container.innerHTML = suggestion.replaceAll(input, `<mark>${input}</mark>`);
  return container
};

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const s=(i,t)=>{const e=i._$AN;if(void 0===e)return  false;for(const i of e)i._$AO?.(t,false),s(i,t);return  true},o$1=i=>{let t,e;do{if(void 0===(t=i._$AM))break;e=t._$AN,e.delete(i),i=t;}while(0===e?.size)},r=i=>{for(let t;t=i._$AM;i=t){let e=t._$AN;if(void 0===e)t._$AN=e=new Set;else if(e.has(i))break;e.add(i),c(t);}};function h$1(i){ void 0!==this._$AN?(o$1(this),this._$AM=i,r(this)):this._$AM=i;}function n$1(i,t=false,e=0){const r=this._$AH,h=this._$AN;if(void 0!==h&&0!==h.size)if(t)if(Array.isArray(r))for(let i=e;i<r.length;i++)s(r[i],false),o$1(r[i]);else null!=r&&(s(r,false),o$1(r));else s(this,i);}const c=i=>{i.type==t$1.CHILD&&(i._$AP??=n$1,i._$AQ??=h$1);};class f extends i$1{constructor(){super(...arguments),this._$AN=void 0;}_$AT(i,t,e){super._$AT(i,t,e),r(this),this.isConnected=i._$AU;}_$AO(i,t=true){i!==this.isConnected&&(this.isConnected=i,i?this.reconnected?.():this.disconnected?.()),t&&(s(this,i),o$1(this));}setValue(t){if(f$1(this._$Ct))this._$Ct._$AI(t,this);else {const i=[...this._$Ct._$AH];i[this._$Ci]=t,this._$Ct._$AI(i,this,0);}}disconnected(){}reconnected(){}}

/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const e=()=>new h;class h{}const o=new WeakMap,n=e$2(class extends f{render(i){return E}update(i,[s]){const e=s!==this.G;return e&&void 0!==this.G&&this.rt(void 0),(e||this.lt!==this.ct)&&(this.G=s,this.ht=i.options?.host,this.rt(this.ct=i.element)),E}rt(t){if(this.isConnected||(t=void 0),"function"==typeof this.G){const i=this.ht??globalThis;let s=o.get(i);void 0===s&&(s=new WeakMap,o.set(i,s)),void 0!==s.get(this.G)&&this.G.call(this.ht,void 0),s.set(this.G,t),void 0!==t&&this.G.call(this.ht,t);}else this.G.value=t;}get lt(){return "function"==typeof this.G?o.get(this.ht??globalThis)?.get(this.G):this.G?.value}disconnected(){this.lt===this.ct&&this.rt(void 0);}reconnected(){this.rt(this.ct);}});

class ProductBlock extends i$2 {
  static get properties() {
    return {
      product: { type: Object },
      price: {
        attribute: 'data-price'
      },
      compareAtPrice: {
        attribute: 'data-compare-at-price'
      },
      loading: {
        type: Boolean
      }
    };
  }

  constructor() {
    super();
    this.loading = true;
  }

  convertUrl(imageUrl) {
    const urlParts = imageUrl.split('?');
    const baseUrl = urlParts[0];
    const queryString = urlParts[1] ? "?" + urlParts[1] : "";
    const extensionMatch = baseUrl.match(/\.\w+$/);
    const extension = extensionMatch ? extensionMatch[0] : '';
    return baseUrl.replace(extension, `_{width}x${extension}`) + queryString;
  }

  getCustomFieldByKey(key) {
    const field = this.product.customFields.find((field) => field.key === key);
    return field ? field.value : null
  }

  updateImage() {
    const img = this.querySelector('img');
    if (img) {
      // Remove the lazyloaded class to allow reprocessing
      img.classList.remove('lazyloaded');

      // Trigger lazysizes to re-evaluate the image
      window.lazySizes.loader.unveil(img);
    }
  }

  updated(changedProperties) {
    if (changedProperties.has('product')) {
      this.updateImage();
      this.dispatchEvent(new CustomEvent('vsk:product:changed', {
        detail: {
          handle: this.product.url.split('/products/')[1].split('/')[0]
        },
        bubbles: true,
        cancelable: false
      }));
    }
  }

  connectedCallback() {
    super.connectedCallback();
    this.price = this.product.price * 100;
    this.compareAtPrice = this.product.listPrice * 100;
  }

  // Disable shadow Root
  createRenderRoot() {
    return this;
  }

  _setImageRatioAfterLoad(event) {
    const image = event.target;
    const width = image.naturalWidth;
    const height = image.naturalHeight;
    const ratio = height / width;
    image.parentElement.style.setProperty('--image-ratio-percent', `${ratio * 100}%`);
  }

  render() {
    return x`
      <div class="product-block__inner ${this.loading ? 'loading' : ''}">
        <div class="product-block__image-wrapper">
          <a
            class="product-block__link"
            href="${this.product.url}"
            aria-label="${this.product.name}"
            tabindex="-1"
          >
            <img
              class="lazyload"
              data-src="${this.convertUrl(this.product.imageUrl)}"
              data-widths="[180, 220, 300, 360, 460, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]"
              data-aspectratio="1.0"
              data-sizes="auto"
              alt="${this.product.name}"
              @load="${this._setImageRatioAfterLoad}"
            />
          </a>
          <button aria-label="Add to Wishlist" data-with-epi="true" class="swym-button swym-add-to-wishlist-view-product swym-inject product_${this.product.productId}" data-swaction="addToWishlist" data-product-id="${this.product.productId}" data-variant-id="${this.product.skus[0].id}" data-product-url="${this.product.url}"></button>
        </div>

        <div class="product-block__info">
          ${this.product.brand ? x`<span class="product-block__brand caption-with-letter-spacing">${this.product.brand}</span>` : ''}
          <span class="product-block__name h4 link">${this.product.name}</span>
          <div class="product-block__prices price">
            ${this.product.listPrice && this.product.listPrice !== this.product.price ? x`<span class="product-block__price-compare"><bdi>${formatMoney(this.compareAtPrice)}</bdi></span>` : ''}
            <span class="product-block__price">${formatMoney(this.price)}</span>
          </div>
        </div>
      </div>
    `
  }
}

customElements.define('product-block', ProductBlock);

const classes$2 = {
  isExpanded: 'expand'
};

class NostoSearchModal extends i$2 {
  static properties = {
    searchTerm: { type: String },
    loading: { type: Boolean },
    results: { type: Array },
    cachedResults: { type: Object },
    placeholder: {
      type: String
    },
    inputToggle: {
      type: Object
    }
  };

  constructor() {
    super();
    this.searchTerm = getParam('q') || '';
    this.loading = false;
    this.results = null;
    this.cachedResults = {};
    this.suggestions = [];
    this.queryArray = [];
    this.searchModal = e();
    this.input = e();
    this.placeholder = 'Search products...';
  }

  connectedCallback() {
    super.connectedCallback();
    this.inputToggleElement = this.inputToggle?.value;
    if (this.string) {
      this.string = JSON.parse(this.string);
    }
  }

  // Disable shadow Root
  createRenderRoot() {
    return this;
  }

  async updated(_changedProperties) {
    super.updated(_changedProperties);
    if (_changedProperties.has('searchTerm')) {
      if (this.inputToggleElement) {
        this.inputToggleElement.value = this.searchTerm;
      }
      await this._performSearch(this.searchTerm);
      if (this.searchModal) {
        this.searchModal.value.classList.toggle(classes$2.isExpanded, this.searchTerm.length >= 2);
      }
    }
  }

  render() {
    const shouldHideClearButton = !this.inputToggleElement && !this.searchTerm;
    return x`
      <div class="search-modal" ${n(this.searchModal)}>
        <div class="page-width">
          <form action="/search" method="get" class="search-modal__form" @submit="${this._handleSearch}">
            <button class="search-button" type="submit">
              <svg class="icon icon-search" aria-hidden="true" focusable="false">
                <use href="#icon-search"></use>
              </svg>
            </button>
            <input
              type="search"
              name="q"
              class="search-modal__input"
              placeholder="${this.placeholder}"
              .value=${this.searchTerm}
              @input=${this._handleInput}
              ${n(this.input)}
            >
            <svg ?hidden=${!this.loading} xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"
                 class="icon icon-spinner" fill="none" viewBox="0 0 66 66">
              <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"/>
            </svg>
            <button
              class="clear-button${this.loading ? ' hidden' : ''}"
              ?hidden="${shouldHideClearButton}"
              type="button"
              @click=${this._handleClearSearch}
            >
              ${this.string.clear}
            </button>
            <button
              class="close-button${this.loading ? ' hidden' : ''}"
              type="button"
              @click=${this._handleCloseSearch}
            >
              <svg class="icon icon-close" aria-hidden="true" focusable="false">
                <use href="#icon-close"></use>
              </svg>
            </button>
          </form>
          ${this.searchTerm.length >= 2 && this.results !== null ? this._renderResults() : ''}
        </div>
      </div>
      <div class="search-modal__overlay" @click=${this._handleCloseSearch}></div>
    `;
  }

  _renderResults() {
    if (!this.results.length) return x`
      <div class="search-modal__no-result">
        <div class="title-wrapper">
          <p class="title h3 title--primary">${this.string.no_results.replace('“{{ terms }}”', this.searchTerm)}</p>
          <p class="typeset">${this.string.check_the_spelling}</p>
        </div>

        <div class="search-modal__search-btn">
          <a href="/search?q=${this.searchTerm}" class="button button--small">
            <span class="text">${this.string.search_for.replace('{{ terms }}', this.searchTerm)}</span>
          </a>
        </div>
      </div>
    `;

    return x`
      <div class="search-modal__content">
        <div class="search-modal__results">
          ${this.suggestions.length ? x`
            <div class="search-modal__suggestions">
              <h2 class="search-modal__suggestions-title">${this.string.suggestions}</h2>
              <div class="search-modal__suggestions-list">
                ${this.suggestions.map((suggestion) => {
                  return x`<a class="search-modal__suggestions-item" href="/search?q=${suggestion.keyword}">
                    <p class="h5 link">${suggestionMark(this.searchTerm, suggestion.keyword)}</p>
                  </a>`
                })}
              </div>
            </div>` : ''}

          <div class="search-modal__products">
            <h2 class="search-modal__products-title">${this.string.products}</h2>
            <div class="search-modal__products-list">
              ${this.results.map((product) => {
                return x`
                  <product-block
                    .product="${product}"
                    data-product-id="${product.pid}"
                    class="product-block">
                  </product-block>`
              })}
            </div>
          </div>
        </div>

        <div class="search-modal__search-btn">
          <a href="/search?q=${this.searchTerm}" class="button button--small">
            <span class="text">${this.string.search_for.replace('{{ terms }}', this.searchTerm)}</span>
          </a>
        </div>
      </div>
    `;
  }

  _handleInput = throttle(async (event) => {
    this.searchTerm = event.target.value;

    if (this.searchTerm.length < 2) {
      this.queryArray = [];
      this._handleCloseSearchModal();
    }
  }, 50);

  async _handleSearch(event) {
    if (this.searchTerm.length < 1) {
      event.preventDefault();
    }
  }

  async _performSearch(query) {
    if (query.length < 2) return;
    if (!!this.cachedResults[query]) {
      this.results = this.cachedResults[query].products;
      this.suggestions = this.cachedResults[query].keywords;
      return;
    }
    this.loading = true;
    try {
      // Replace with your actual search endpoint
      this.queryArray.push(query);

      const results = await getSearchResults(query);

      const prevQuery = this.getAttribute('data-query');
      const prevQueryIndex = this.queryArray?.lastIndexOf(prevQuery);
      const currentQueryIndex = this.queryArray?.lastIndexOf(query);

      if (prevQueryIndex !== -1 && prevQueryIndex >= currentQueryIndex && !(prevQueryIndex === 0 && currentQueryIndex === 0)) {
        return;
      }

      const products = results.data.search.products?.hits;
      const keywords = results.data.search.keywords?.hits;

      this.cachedResults[query] = {
        products: products.length ? products : [],
        keywords: keywords && keywords.length ? keywords : []
      };

      if (products.length) {
        this.results = products;
      } else {
        this.results = [];
      }

      if (keywords && keywords.length) {
        this.suggestions = keywords;
      } else {
        this.suggestions = [];
      }

      this.setAttribute('data-query', query);
      this.loading = false;
    } catch (error) {
      console.error('Search failed:', error);
      this.results = [];
      this.loading = false;
    }
  }

  _handleClearSearch() {
    this.searchTerm = '';
    this._handleCloseSearchModal();
  }

  _handleCloseSearch() {
    if (this.searchBar) {
      this.searchBar.dispatchEvent(new CustomEvent('modal-close'));
    }
  }

  _handleCloseSearchModal() {
    if (this.searchModal) {
      this.searchModal.value.classList.remove(classes$2.isExpanded);
    }
  }
}

customElements.define('nosto-search-modal', NostoSearchModal);

class NostoSearchBar extends i$2 {
  static properties = {
    open: {
      type: Boolean,
      reflect: true
    },
    toggle: {
      type: String
    },
    placeholder: {
      type: String
    },
    string: {}
  };

  constructor() {
    super();
    this.open = false;
    this.toggle = 'icon';
    this.placeholder = 'Search product...';
    this.inputRef = e();

    const header = document.querySelector('.shopify-section-header');
    if (header) {
      document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
    }

    this.addEventListener('modal-close', () => {
      this.open = false;
      this.querySelector('details').open = false;
      document.body.removeAttribute('open-search-modal');
    });
  }

  connectedCallback() {
    super.connectedCallback();

    const stringAttr = this.getAttribute('string');
    if (stringAttr) {
      this.string = stringAttr;
    }
  }

  // Disable shadow Root
  createRenderRoot() {
    return this;
  }

  _renderToggleIcon() {
    return x`
      <summary class="header__icon header__icon--summary header__icon--search focus-inset modal__toggle">
        <span>
          <svg class="icon icon-search modal__toggle-open" aria-hidden="true" focusable="false">
            <use href="#icon-search"></use>
          </svg>
          <svg class="icon icon-close modal__toggle-close" aria-hidden="true" focusable="false">
            <use href="#icon-close"></use>
          </svg>
          <p class="header-input">
            <a class="searchfame">Search Fame</a>
          </p>
        </span>
      </summary>
    `
  }

  _renderToggleInput() {
    return x`
      <summary class="input-toggle">
        <button class="input-toggle__button" type="button" @click="${this._handleSearch}">
          <svg class="icon icon-search modal__toggle-open" aria-hidden="true" focusable="false">
            <use href="#icon-search"></use>
          </svg>
        </button>
        <input
          class="field__input input-toggle__input"
          type="text"
          placeholder="${this.placeholder}"
          name="q"
          autocomplete="off"
          role="combobox"
          @focus="${this._openModal}"
          ${n(this.inputRef)}
        >
      </summary>
    `
  }

  render() {
    return x`
      <details @toggle=${this._handleToggle} class="search-bar search-bar--${this.toggle}">
        ${this.toggle === 'icon' ? this._renderToggleIcon() : this._renderToggleInput()}
        <nosto-search-modal
          class="${this.open ? 'open' : ''}"
          .toggle=${this._handleToggle}
          .searchBar=${this}
          .string=${this.string}
          .placeholder="${this.placeholder}"
          .inputToggle=${this.inputRef}
        >
        </nosto-search-modal>
      </details>
    `;
  }

  _handleToggle(e) {
    setScrollbarWidth();
    this._setHeaderBottomPosition();
    this.open = e.target.open;

    if (e.target.open) {
      if (this.toggle !== 'input') {
        document.body.setAttribute('open-search-modal', 'true');
      }

      const searchInput = this.querySelector('.search-modal__input');
      if (searchInput) {
        setTimeout(() => {
          searchInput.focus();
        }, 500);
      }
    }
  }

  _openModal() {
    this.open = true;
    this.querySelector('details').open = true;
  }

  _setHeaderBottomPosition() {
    const header = document.querySelector('.shopify-section-header');
    if (header) {
      const headerClientRect = header.getBoundingClientRect();
      document.documentElement.style.setProperty('--header-bottom-position', `${headerClientRect.bottom}px`);
    }
  }

  _handleSearch() {
    if (!this.inputRef.value || this.inputRef.value.value.length < 1) return;
    window.location = `/search?q=${this.inputRef.value.value}`;
  }
}

customElements.define('nosto-search-bar', NostoSearchBar);

const classes$1 = {
  isOpen: 'is-open',
  isDrawerOpen: 'is-drawer-open'
};

class SideDrawer extends i$2 {
  static properties = {
    open: {
      type: Boolean
    },
    position: {
      type: String
    },
    handleClose: {
      type: Function
    }
  }

  constructor() {
    super();
    this.open = false;
    this.position = 'left';
    this.handleClose = () => {
    };
  }

  connectedCallback() {
    super.connectedCallback();
  }

  createRenderRoot() {
    return this;
  }

  updated(_changedProperties) {
    Promise.resolve().then(() => {
      const slottedChildren = Array.from(this.querySelectorAll("[slot='content']"));
      const slot = this.querySelector("[data-slot='content']");
      if (!slot) return;
      slottedChildren.forEach((child) => {
        slot.appendChild(child);
      });
    });

    if (_changedProperties.has('open')) {
      if (this.open) {
        document.body.classList.add(classes$1.isDrawerOpen);
      } else {
        document.body.classList.remove(classes$1.isDrawerOpen);
      }
    }
  }

  render() {
    return x`
        <aside class="drawer drawer--${this.position} ${this.open ? classes$1.isOpen : ''}">
            <button class="button--plain drawer__close-button" type="button" @click="${this.handleClose}">
                <svg class="icon icon-close" aria-hidden="true" focusable="false">
                    <use href="#icon-close"></use>
                </svg>
            </button>
            <div class="drawer__content" data-slot="content"></div>
        </aside>
        <div class="drawer__overlay ${this.open ? classes$1.isOpen : ''}" @click="${this.handleClose}"></div>
    `
  }
}

customElements.define('side-drawer', SideDrawer);

const classes = {
  isActive: 'is-active'
};

const selectors = {
  dropdown: '.js-dropdown'
};

class InputDropdown extends i$2 {
  static properties = {
    options: {
      type: Array
    },
    selectedIndex: {
      type: Number
    },
    name: {
      type: String
    },
    onChange: {
      type: Function
    },
    label: {
      type: String
    }
  }

  constructor() {
    super();
    this.options = [];
    this.selectedIndex = 0;
    this.name = 'dropdown';
    this.onChange = () => {};
    this.label = 'Sort by';
  }

  connectedCallback() {
    super.connectedCallback();
  }

  firstUpdated() {
    this.dropdown = this.querySelector(selectors.dropdown);
  }

  createRenderRoot() {
    return this
  }

  _handleOptionChange(event, index) {
    this.selectedIndex = index;
    this.onChange(event);
    this._closeDropdown();
  }

  _closeDropdown() {
    if (!this.dropdown) return
    this.dropdown.removeAttribute('open');
  }

  _renderOptions() {
    return this.options.map((option, index) => {
      const { label, value } = option;
      const optionId = `${label}-${value}`;
      const isSelected = index === this.selectedIndex;
      return x`
        <li class="dropdown__option">
          <label class="dropdown__label ${isSelected ? classes.isActive : ''}" for="${optionId}">
            <input
              class="visually-hidden"
              type="radio"
              name="${this.name}"
              id="${optionId}"
              value="${value}"
              ?checked="${isSelected}"
              @change="${(e) => {
                this._handleOptionChange(e, index);
              }}"
            >
            <span class="dropdown__label-text">${label}</span>
          </label>
        </li>
      `
    })
  }

  render() {
    return x`
      <details class="dropdown js-dropdown">
        <summary class="button button--tertiary button--small uppercase dropdown__summary">
          <span>${this.label}</span>
          <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-caret" fill="none" viewBox="0 0 24 15">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 15c-.3 0-.6-.1-.8-.4l-11-13C-.2 1.2-.1.5.3.2c.4-.4 1.1-.3 1.4.1L12 12.5 22.2.4c.4-.4 1-.5 1.4-.1.4.4.5 1 .1 1.4l-11 13c-.1.2-.4.3-.7.3z" fill="currentColor"></path>
          </svg>
        </summary>
        <ul class="dropdown__options">${this._renderOptions()}</ul>
      </details>
    `
  }
}

customElements.define('input-dropdown', InputDropdown);

document.addEventListener('DOMContentLoaded', () => {
  if (theme.settings.enable_nosto_api_search && theme.settings.template === 'search') {
    collectionGrid();
  }

  document.addEventListener('scroll', function () {
    const images = document.querySelectorAll('.lazyautosizes');
    if (images.length) {
      images.forEach((image) => {
        const src = image.getAttribute('data-src-temp');
        const srcset = image.getAttribute('data-srcset');
        if (srcset) return;
        image.setAttribute('data-src', src);
        image.removeAttribute('data-src-temp');
        lazySizes.loader.unveil(image);
      });
    }
  }, {
    passive: true
  });
});
